<!--
  TEMP DISABLE FEATURES - 暫時關閉功能
  
  已暫時關閉以下功能：
  1. 驗證碼保護 (showAuthenticatorProtection: false)
  2. QR碼掃描 disable 邏輯 (showQRCode 已從 disable 條件中移除)
  
  恢復方法：
  1. 將 line ~960: showAuthenticatorProtection 改回 true
  2. 在身分證輸入框和搜尋按鈕的 :disabled 條件中加回 "|| showQRCode"
  
  修改日期：2025-08-15
  修改原因：暫時關閉驗證碼和QR掃描功能，直接顯示身分證號碼輸入
-->
<template>
  <div class="p-2">
    <modal-PDF
      @refetch-newest-data="triggerModalSearchInfo"
      @refetch-supplier-info="fetchSuppliersInfo"
      @update-search-count="updateSearchCount"
      @update-loan-count="updateLoanCount"
      :ability="ability"
      :getPdfData="pdfData"
      :number_of_search="number_of_search"
      :number_of_loan="number_of_loan"
    ></modal-PDF>
    <modal-member-contract></modal-member-contract>
    <!-- @refetch-member-contract="fetchMemberContracts" -->
    <modal-search-form
      :modalTitle="formTitle"
      @refetch-data="refetchData"
      :hkid="hkid"
    ></modal-search-form>

    
    <!-- 查看報告 Modal -->
    <b-modal
      v-model="showViewReportModalFlag"
      title="查看報告"
      size="md"
      centered
      hide-footer
    >
      <div class="p-3">
        <p class="mb-3">請輸入身分證號碼查看報告：</p>
        <b-form-group
          label="身分證號碼"
          label-for="view-report-id-number"
        >
          <b-form-input
            id="view-report-id-number"
            v-model="viewReportIdNumber"
            type="text"
            placeholder="例如：A123456(7) 或 1234567(8)"
            @keyup.enter="viewReportByIdNumber"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            @click="showViewReportModalFlag = false"
            class="mr-2"
          >
            取消
          </b-button>
          <b-button
            variant="primary"
            @click="viewReportByIdNumber"
          >
            查看報告
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- QR碼確認搜尋對話框 -->
    <b-modal
      id="modal-qr-confirm"
      v-model="showQRConfirmModal"
      title="掃描QR碼確認搜尋"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="qrCodeData" class="text-center">
        <!-- QR碼顯示區域 -->
        <div class="qr-code-container mb-4">
          <div class="qr-code-wrapper" v-html="qrCodeData.qr_code"></div>
        </div>

        <!-- 搜尋參數顯示 -->
        <div class="search-params-info mb-4">
          <h6 class="text-primary mb-3">搜尋參數</h6>
          <div class="param-item">
            <strong>身分證號碼：</strong>{{ qrCodeData.search_params.q }}
          </div>
          <div
            v-if="qrCodeData.search_params.is_out_of_half_year"
            class="param-item"
          >
            <strong>半年外個人財務狀況：</strong>是
          </div>
          <div
            v-if="qrCodeData.search_params.is_out_of_fifteen_days"
            class="param-item"
          >
            <strong>15日以外查詢紀錄：</strong>是
          </div>
        </div>

        <!-- 狀態顯示 -->
        <div class="status-info mb-4">
          <div v-if="qrConfirmStatus === 'pending'" class="status-pending">
            <b-spinner small class="mr-2"></b-spinner>
            <span
              >等待手機確認中... ({{
                Math.ceil(((maxPollingCount - qrPollingCount) * 2) / 60)
              }}分鐘後過期)</span
            >
          </div>
          <div
            v-else-if="qrConfirmStatus === 'confirmed'"
            class="status-confirmed text-success"
          >
            <feather-icon icon="CheckCircleIcon" class="mr-2"></feather-icon>
            <span>確認成功，正在執行搜尋...</span>
          </div>
          <div
            v-else-if="qrConfirmStatus === 'expired'"
            class="status-expired text-warning"
          >
            <feather-icon icon="AlertTriangleIcon" class="mr-2"></feather-icon>
            <span>QR碼已過期</span>
          </div>
        </div>

        <!-- 說明文字 -->
        <div class="instructions text-muted">
          <p class="mb-2">
            <feather-icon
              icon="SmartphoneIcon"
              size="16"
              class="mr-1"
            ></feather-icon>
            請使用手機App掃描上方QR碼
          </p>
          <p class="mb-2">
            <feather-icon
              icon="ShieldIcon"
              size="16"
              class="mr-1"
            ></feather-icon>
            確認搜尋參數後點擊確認
          </p>
          <p class="mb-0">
            <feather-icon
              icon="ClockIcon"
              size="16"
              class="mr-1"
            ></feather-icon>
            QR碼將在5分鐘後自動過期
          </p>
        </div>

        <!-- 操作按鈕 -->
        <div class="action-buttons mt-4">
          <b-button
            variant="outline-secondary"
            @click="closeQRConfirmModal"
            class="mr-2"
          >
            取消
          </b-button>
          <b-button
            variant="primary"
            @click="refreshQRCode"
            disabled
          >
            重新生成QR碼 (已禁用)
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- 走馬燈通告區域 -->
      <div 
        v-if="showMarquee && latestAnnouncement"
        class="announcement-marquee-container mb-3"
        @click.stop="showAnnouncementModal"
      >
        <div class="announcement-marquee">
          <div class="marquee-content">
            <div class="marquee-item">
              <span class="announcement-title">
                <feather-icon icon="InfoIcon" size="16" />
                通告：
              </span>
              <span v-if="latestAnnouncement.title && false" class="announcement-title">
                {{ latestAnnouncement.title }}
              </span>
              <span class="announcement-text">
                {{ htmlToText(latestAnnouncement.content) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <b-card>
        <div class="d-flex flex-wrap align-items-center">
          <span class="text-nowrap font-weight-bolder pr-1">做客數值：</span>
          <b-row
            v-if="get_supplier_info"
            class="records_count_card flex-grow-1 justify-content-center"
          >
            <div class="info-item mr-2">
              <b class="">搜尋：</b
              ><span> {{ get_supplier_info.search_records_count }}次 </span>
            </div>
            <div class="info-item mr-2">
              <b class="">拒絕紀錄：</b
              ><span>{{ get_supplier_info.reject_records_count }}次</span>
            </div>
            <div class="info-item mr-2">
              <b class="">財務狀況：</b
              ><span>{{ get_supplier_info.client_loans_count }}次</span>
            </div>
            <div class="info-item mr-2">
              <b class="">帳務紀錄：</b
              ><span>{{ get_supplier_info.account_records_count }}次</span>
            </div>
            <div class="info-item mr-2">
              <b class="">無上傳記錄：</b><span>{{ calNoUpload }}次</span>
            </div>
            <div class="info-item mr-2">
              <b class="">上傳率：</b><span>{{ calUploadRate }}%</span>
            </div>
            <div class="info-item mr-2">
              <b class="">持有合約：</b
              ><span>{{ get_supplier_info.contract_count }}份</span>
            </div>
            <div class="info-item mr-2">
              <b class="">會員：</b
              ><a
                class="text-underline text-primary"
                href="javascript:void(0)"
                @click="triggerModalMemberContract"
                >{{ get_supplier_info.is_member ? "是" : "否" }}</a
              >
            </div>
            <div class="info-item mr-2">
              <b class="">會員到期日：</b
              ><span
                :class="{
                  'text-danger font-weight-bold': isMembershipExpired,
                }"
                >{{ get_supplier_info.membership_expiry_date }}</span
              >
            </div>
            <div class="info-item mr-2">
              <b class="">放債人牌照到期日：</b>
              <span v-if="hasPendingMoneylenderRequest" class="text-warning font-weight-bold">
                待批核
              </span>
              <span v-else-if="get_supplier_info && get_supplier_info.moneylender_license_expiry_date"
                    :class="{
                      'text-danger font-weight-bold': isMoneylenderLicenseExpired,
                    }">
                {{ get_supplier_info.moneylender_license_expiry_date }}
              </span>
              <span v-else class="text-muted">未設定</span>
              <b-button
                v-if="!hasPendingMoneylenderRequest"
                variant="outline-primary"
                size="sm"
                class="ml-2"
                @click="handleMoneylenderLicenseAction"
              >
                {{ get_supplier_info && get_supplier_info.moneylender_license_expiry_date ? '修改' : '設定' }}
              </b-button>
            </div>
            <div class="info-item mr-2">
              <b class="">免費搜尋次數：</b
              ><span>{{ get_supplier_info.search_limit }}次</span>
            </div>
            <div class="info-item mr-2">
              <b class="">X Coin 餘額：</b><span>{{ coinBalance }}</span>
            </div>
          </b-row>
        </div>
      </b-card>




      <b-tabs card class="dashboard-tabs">
            <b-tab title="信貸資料" active style="background:white;">
              <b-card>
        <!-- 查看報告按鈕區域 -->
        <div v-if="canViewReportDirectly" class="mb-3">
          <b-button
            variant="outline-primary"
            @click="showViewReportModal"
            class="mr-2"
          >
            <feather-icon size="16" icon="FileTextIcon" class="mr-1"></feather-icon>
            查看報告
          </b-button>
          <span class="text-muted">無需驗證即可直接查看報告</span>
        </div>
        
        <!-- 會員過期提示 -->
        <b-alert v-if="isMembershipExpired" show variant="danger" class="mb-3">
          <div class="alert-heading d-flex align-items-center">
            <feather-icon
              icon="AlertTriangleIcon"
              class="mr-1"
              size="24"
            ></feather-icon>
            <h4 class="mb-0">會員已過期</h4>
          </div>
          <p class="mb-0">
            您的會員已於
            {{ get_supplier_info.membership_expiry_date }}
            過期，請聯繫管理員進行續費。
          </p>
        </b-alert>

        <!-- 上傳率過低提示 -->
        <b-alert v-if="isUploadRateDisabled" show variant="danger" class="mb-3">
          <div class="alert-heading d-flex align-items-center">
            <feather-icon
              icon="AlertTriangleIcon"
              class="mr-1"
              size="24"
            ></feather-icon>
            <h4 class="mb-0">上傳率過低</h4>
          </div>
          <p class="mb-0">
            因上傳率不足，您的查詢功能已被停用，請聯絡我們的客服。
          </p>
        </b-alert>

        <!-- 放債人牌照過期提示 -->
        <b-alert v-if="isMoneylenderLicenseExpired" show variant="warning" class="mb-3">
          <div class="alert-heading d-flex align-items-center">
            <feather-icon
              icon="AlertTriangleIcon"
              class="mr-1"
              size="24"
            ></feather-icon>
            <h4 class="mb-0">放債人牌照問題</h4>
          </div>
          <p class="mb-0">
            <span v-if="!get_supplier_info || !get_supplier_info.moneylender_license_expiry_date">
              您尚未設定放債人牌照到期日，無法進行搜尋驗證。
            </span>
            <span v-else>
              您的放債人牌照已於
              {{ get_supplier_info.moneylender_license_expiry_date }}
              過期，無法進行搜尋驗證。
            </span>
            請點擊上方的「設定」或「修改」按鈕更新您的放債人牌照資料。所有操作均需通過 OTP 驗證確保安全。
          </p>
        </b-alert>





        <!-- 搜尋選項區域 - 只有驗證通過後才顯示 -->
        <div
          v-if="!showAuthenticatorProtection"
          class="d-flex flex-wrap flex-sm-nowrap"
        >
          <div class="d-flex flex-wrap flex-md-nowrap align-items-center">
            <!-- <div class="mx-1">
              <font-awesome-icon icon="fa-solid fa-address-card" />
            </div> -->
            <span class="text-nowrap font-weight-bolder pr-1"
              >身分證號碼：</span
            >
            <div class="d-flex">
              <div
                v-if="
                  false &&
                  this.$store.state.app.user_info &&
                  this.$store.state.app.user_info.info.coin_extra_records
                "
                class="d-flex flex-column mr-3"
              >
                <div class="d-flex align-items-center">
                  <span style="white-space: nowrap">半年外個人財務狀況：</span>
                  <b-form-checkbox
                    v-model="is_out_of_half_year"
                    class="mr-0"
                    inline
                    :disabled="isMembershipExpired || isMoneylenderLicenseExpired || isUploadRateDisabled"
                  />
                </div>
                <small class="text-muted ml-4" v-if="is_out_of_half_year">
                  (額外扣除：{{
                    get_supplier_info.search_limit > 0
                      ? "1次免費搜尋次數"
                      : coinExtraRecords + " X Coin"
                  }})
                </small>
              </div>
              <div
                v-if="
                  false &&
                  this.$store.state.app.user_info &&
                  this.$store.state.app.user_info.info.coin_extra_records
                "
                class="d-flex flex-column"
              >
                <div class="d-flex align-items-center">
                  <span style="white-space: nowrap">15日以外查詢紀錄：</span>
                  <b-form-checkbox
                    v-model="is_out_of_fifteen_days"
                    class="mr-0"
                    inline
                    :disabled="isMembershipExpired || isMoneylenderLicenseExpired || isUploadRateDisabled"
                  />
                </div>
                <small class="text-muted ml-4" v-if="is_out_of_fifteen_days">
                  (額外扣除：{{
                    get_supplier_info.search_limit > 0
                      ? "1次免費搜尋次數"
                      : coinExtraSearchRecords + " X Coin"
                  }})
                </small>
              </div>
            </div>
          </div>

          <!-- 搜尋功能區域 - 只有驗證通過後才顯示 -->
          <div v-if="!showAuthenticatorProtection" class="w-100">
            <!-- QR碼顯示區域 -->
            <div v-if="showQRCode" class="qr-code-section mb-3">
              <div class="qr-code-container">
                <div class="qr-code-header text-center mb-3">
                  <h6 class="text-primary mb-2">
                    <feather-icon
                      icon="SmartphoneIcon"
                      size="16"
                      class="mr-1"
                    ></feather-icon>
                    請使用手機App掃描QR碼確認搜尋
                  </h6>
                  <div class="qr-status-info">
                    <span
                      v-if="qrConfirmStatus === 'pending'"
                      class="text-info"
                    >
                      <b-spinner small class="mr-1"></b-spinner>
                      等待確認中... ({{ qrRefreshCountdown }}秒後更新)
                    </span>
                    <span
                      v-else-if="qrConfirmStatus === 'confirmed'"
                      class="text-success"
                    >
                      <feather-icon
                        icon="CheckCircleIcon"
                        size="16"
                        class="mr-1"
                      ></feather-icon>
                      確認成功，正在執行搜尋...
                    </span>
                    <span
                      v-else-if="qrConfirmStatus === 'expired'"
                      class="text-warning"
                    >
                      <feather-icon
                        icon="AlertTriangleIcon"
                        size="16"
                        class="mr-1"
                      ></feather-icon>
                      QR碼已過期
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 text-center">
                    <!-- QR碼顯示 - 參考SuppliersList.vue的成功實現 -->
                    <div
                      v-if="qrCodeData && qrCodeData.qr_code"
                      v-html="qrCodeData.qr_code"
                      class="qr-code-container"
                    ></div>
                    <div v-else-if="qrCodeData" class="qr-code-loading">
                      <b-spinner class="mr-2"></b-spinner>
                      <span>正在生成QR碼...</span>
                    </div>
                    <div v-else class="qr-code-placeholder">
                      <span class="text-muted">等待QR碼生成...</span>
                    </div>

                    <!-- 調試信息 -->
                    <div
                      v-if="qrCodeData"
                      class="debug-info mt-2"
                      style="font-size: 10px; color: #666"
                    >
                      <div>Token: {{ getTokenDisplay() }}</div>
                      <div>
                        QR Code Length:
                        {{ qrCodeData.qr_code ? qrCodeData.qr_code.length : 0 }}
                      </div>
                      <div>QR Code Type: {{ typeof qrCodeData.qr_code }}</div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <!-- 搜尋參數顯示 -->
                    <div class="search-params-summary">
                      <h6 class="text-secondary mb-2">搜尋參數</h6>
                      <div class="param-item mb-2" v-if="qrCodeData">
                        <strong>身分證號碼：</strong
                        >{{ qrCodeData.search_params.q }}
                      </div>
                      <div
                        v-if="
                          qrCodeData &&
                          qrCodeData.search_params.is_out_of_half_year
                        "
                        class="param-item mb-2"
                      >
                        <strong>半年外個人財務狀況：</strong>是
                      </div>
                      <div
                        v-if="
                          qrCodeData &&
                          qrCodeData.search_params.is_out_of_fifteen_days
                        "
                        class="param-item mb-2"
                      >
                        <strong>15日以外查詢紀錄：</strong>是
                      </div>

                      <!-- 費用計算顯示 -->
                      <div 
                        v-if="searchCostCalculation.coinNeeded > 0"
                        class="cost-calculation mt-3 pt-3 border-top"
                      >
                        <h6 class="text-info mb-2">費用計算</h6>
                        <div class="cost-item mb-1">
                          <small>
                            <strong>免費搜尋次數：</strong>
                            <span class="text-success"
                              >{{
                                searchCostCalculation.freeSearchToUse
                              }}次</span
                            >
                            <span
                              v-if="searchCostCalculation.freeSearchToUse > 0"
                            >
                              (剩餘{{
                                get_supplier_info.search_limit -
                                searchCostCalculation.freeSearchToUse
                              }}次)</span
                            >
                          </small>
                        </div>
                        <div class="cost-item mb-1">
                          <small>
                            <strong>需要X Coin：</strong>
                            <span v-if="searchCostCalculation.coinNeeded > 0" class="text-warning">
                              {{ searchCostCalculation.coinNeeded }}
                              <span> (餘額{{ coinBalance }})</span>
                            </span>
                            <span v-else class="text-success font-weight-bold">免費</span>
                          </small>
                        </div>
                        <div class="cost-breakdown mt-2">
                          <small class="text-muted">
                            <div>
                              • 基本搜尋：
                              <span v-if="searchCostCalculation.basicSearchCost > 0">
                                {{ searchCostCalculation.basicSearchCost }} X Coin
                              </span>
                              <span v-else class="text-success">免費</span>
                            </div>
                            <div
                              v-if="
                                qrCodeData &&
                                qrCodeData.search_params.is_out_of_half_year
                              "
                            >
                              • 半年外個人財務狀況：
                              <span v-if="getCoinExtraRecords > 0">
                                {{ getCoinExtraRecords }} X Coin
                              </span>
                              <span v-else class="text-success">免費</span>
                            </div>
                            <div
                              v-if="
                                qrCodeData &&
                                qrCodeData.search_params.is_out_of_fifteen_days
                              "
                            >
                              • 15日以外查詢紀錄：
                              <span v-if="getCoinExtraSearchRecords > 0">
                                {{ getCoinExtraSearchRecords }} X Coin
                              </span>
                              <span v-else class="text-success">免費</span>
                            </div>
                          </small>
                        </div>
                      </div>
                    </div>

                    <!-- 操作按鈕 -->
                    <div class="qr-actions mt-3 d-flex align-items-center">
                      <b-button
                        variant="outline-secondary"
                        size="sm"
                        @click="cancelQRConfirm"
                        class="mr-2"
                      >
                        取消
                      </b-button>
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="refreshQRCode"
                        disabled
                        style="white-space: nowrap;"
                      >
                        更新QR碼 (已禁用)
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 搜尋輸入區域 -->
            <div class="d-flex flex-wrap flex-sm-nowrap">
              <!-- 身分證號碼輸入欄 - TEMP: 已移除 showQRCode disable 條件 -->
              <b-form-input
                v-model="searchQuery"
                type="text"
                class="mr-0 mr-sm-2 mt-1 m-sm-0"
                v-on:keyup.enter="triggerSearchConfirm"
                placeholder="輸入身分證號碼 e.g. A123456(7) 或 1234567(8)"
                :disabled="isMembershipExpired || isMoneylenderLicenseExpired || isUploadRateDisabled"
              ></b-form-input>
              <!-- TEMP: 搜尋按鈕 - 已移除 showQRCode disable 條件 -->
              <b-button
                class="bgColor0 text-nowrap mt-1 m-sm-0"
                @click="triggerSearchConfirm"
                :disabled="isMembershipExpired || isMoneylenderLicenseExpired || isUploadRateDisabled"
              >
                <feather-icon size="16" icon="SearchIcon"></feather-icon>
                搜尋
              </b-button>
            </div>
          </div>
        </div>

        <!-- 安全驗證區域 - 當需要驗證時顯示 -->
        <div v-if="showAuthenticatorProtection" class="mt-3">
          <div class="card border-primary">
            <div class="card-body py-3">
              <div class="row align-items-center">
                <div class="col-md-3 col-sm-12 mb-2 mb-md-0">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      size="20"
                      icon="ShieldIcon"
                      class="text-primary mr-2"
                    ></feather-icon>
                    <h6 class="mb-0 font-weight-bold text-primary">安全驗證</h6>
                  </div>
                  <small class="text-muted"
                    >請輸入手機APP驗證碼以繼續搜尋記錄</small
                  >
                </div>

                <div class="col-md-4 col-sm-6 mb-2 mb-md-0">
                  <b-form-input
                    v-model="authenticatorCode"
                    type="text"
                    maxlength="6"
                    placeholder="6位驗證碼"
                    @input="onAuthenticatorCodeInput"
                    @keyup.enter="
                      authenticatorCode.length === 6 &&
                        !verifyingCode &&
                        !isMoneylenderLicenseExpired &&
                        !isUploadRateDisabled &&
                        verifyAuthenticatorCode()
                    "
                    :class="[
                      'text-center font-weight-bold',
                      { 'authenticator-input-highlight': showInputHighlight },
                    ]"
                    :disabled="isMoneylenderLicenseExpired || isUploadRateDisabled"
                    style="letter-spacing: 3px; font-size: 16px"
                  ></b-form-input>
                </div>

                <div class="col-md-2 col-sm-6 mb-2 mb-md-0">
                  <b-button
                    variant="primary"
                    @click="verifyAuthenticatorCode"
                    :disabled="authenticatorCode.length !== 6 || verifyingCode || isMoneylenderLicenseExpired || isUploadRateDisabled"
                    class="w-100"
                  >
                    <b-spinner
                      small
                      v-if="verifyingCode"
                      class="mr-1"
                    ></b-spinner>
                    {{ verifyingCode ? "驗證中..." : "驗證並繼續" }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <div class="d-flex flex-wrap mb-1 justify-content-between">
        <div class="d-flex align-items-center ml-2">
          <div class="">
            <!-- <feather-icon size="16" icon="SearchIcon"></feather-icon> -->
            <span class="title-size">過往搜尋記錄</span>
          </div>
          <div class="form-col-select ml-2">
            <v-select
              style="width: 100px"
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block"
            />
            <feather-icon size="18" icon="ChevronDownIcon" />
          </div>
        </div>
        <!-- <div
          class="d-flex flex-wrap flex-md-nowrap align-items-center mt-1 mt-md-0 max-md-w100"
        >
          <span class="title-size text-nowrap mr-1"
            >身份證號碼(15日內搜尋紀錄)：</span
          >
          <div class="search-primary">
            <feather-icon size="16" icon="SearchIcon" />
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="15日內Free搜尋"
            />
          </div>
        </div> -->
      </div>

      <b-card no-body class="card-statistics p-1 p-sm-0">
        <b-card-body class="">
          <b-table
            ref="refSearchListTable"
            class="position-relative"
            :items="fetchSearchs"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="未找到匹配的記錄"
            :sort-desc.sync="isSortDirDesc"
          >
            <!-- Column: search_key_words -->
            <!-- <template #cell(search_key_words)="data">
              <div class="d-flex align-items-center">
                <span class="mr-1 text-nowrap">
                  <feather-icon
                    class="mr-1"
                    size="16"
                    icon="SearchIcon"
                  ></feather-icon>
                  <span>搜尋：</span>
                </span>

                <span>
                  {{ data.item.search_key_words }}
                </span>
              </div>
            </template> -->

            <!-- Column: create time -->
            <template #cell(created_at)="data">
              {{ getCorrectDateTime(data.item.created_at) }}
            </template>

            <!-- Column: New Activity Status -->
            <template #cell(new_activity_status)="data">
              <template v-if="data.item.showreport">
                <div class="d-flex align-items-center justify-content-center">
                  <template v-if="data.item.has_new_activity">
                    <b-badge
                      variant="warning"
                      style="cursor: pointer;"
                      @click="handleNewActivityClick(data.item)"
                      v-b-popover.hover.bottom="
                        '檢測到該客戶有新的活動記錄，點擊購買最新報告'
                      "
                      title="點擊購買更新報告"
                    >
                      <feather-icon
                        icon="AlertTriangleIcon"
                        size="12"
                        class="mr-1"
                      ></feather-icon>
                      有新活動
                    </b-badge>
                    <b-button
                      v-if="
                        false &&
                        data.item.new_activity_details &&
                        data.item.new_activity_details.length > 0
                      "
                      variant="outline-info"
                      size="sm"
                      v-b-popover.hover.top="
                        getActivityDetailsText(data.item.new_activity_details)
                      "
                      title="新活動詳情"
                    >
                      <feather-icon icon="InfoIcon" size="12"></feather-icon>
                    </b-button>
                  </template>
                  <template v-else>
                    <b-badge variant="success">
                      <feather-icon
                        icon="CheckIcon"
                        size="12"
                        class="mr-1"
                      ></feather-icon>
                      無新活動
                    </b-badge>
                  </template>
                </div>
              </template>
              <template v-else>
                -
              </template>
            </template>

            <!-- Column: Download -->
            <template #cell(actions)="data">
              <template v-if="!data.item.is_error">
                <a
                  v-if="data.item.showreport"
                  href="javascript:void(0)"
                  @click="triggerModalSearchInfo(data.item.id)"
                >
                  <font-awesome-icon
                    class="color0"
                    style="font-size: 20px"
                    icon="fa-solid fa-file"
                  />
                </a>
                <div v-else>已過期</div>
              </template>
              <template v-else>
                <div
                  class="error-exclamation"
                  v-b-popover.hover.top="data.item.error_message"
                  title="錯誤！"
                >
                  <font-awesome-icon icon="fa-solid fa-exclamation" />
                </div>
              </template>
            </template>
          </b-table>
          <div class="mx-2 my-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                  {{ dataMeta.to }} 個記錄</span
                >
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalSearchs"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-card>
            </b-tab>
            <b-tab title="破產記錄" class="p-0">
              <b-card>
                <b-card-header>
                  <div class="d-flex justify-content-between align-items-center">
                    <b-card-title class="ml-1 mb-0">破產記錄及法院案件查詢</b-card-title>
                    <small class="text-muted font-italic">*法庭案件資料由2025年9月16日開始提供</small>
                  </div>
                </b-card-header>
                <b-card-body>
                  <!-- 搜尋區域 -->
                  <b-row class="mb-4 align-items-end">
                    <b-col cols="12" md="8" class="mt-1">
                      <b-form-group label="姓名/案件編號/當事人搜尋" label-for="unified-search" class="mb-0">
                        <b-form-input
                          id="unified-search"
                          v-model="unifiedSearchQuery"
                          placeholder="請輸入姓名、案件編號或當事人進行查詢..."
                          @input="onUnifiedSearchInput"
                          @keyup.enter="searchUnifiedRecords"
                          class="search-input"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4">
                      <div class="d-flex">
                        <b-button
                          variant="primary"
                          @click="searchUnifiedRecords"
                          :disabled="unifiedLoading || !unifiedSearchQuery.trim()"
                          class="mr-2 btn-same-height"
                        >
                          <feather-icon icon="SearchIcon" size="16" class="mr-1" />
                          搜尋
                        </b-button>
                        <b-button
                          variant="outline-secondary"
                          @click="clearUnifiedSearch"
                          :disabled="unifiedLoading"
                          class="btn-same-height"
                        >
                          <feather-icon icon="XIcon" size="16" class="mr-1" />
                          清除
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- 結果統計區域 -->
                   <!--
                  <div v-if="bankruptcyRecords.length > 0 || courtCasesRecords.length > 0" class="mb-4">
                    <div class="row">
                      <div v-if="bankruptcyRecords.length > 0" class="col-md-6 mb-2">
                        <div class="search-result-compact d-flex align-items-center px-3 py-2 rounded">
                          <feather-icon icon="FileTextIcon" size="16" class="text-success mr-2" />
                          <span class="text-muted">
                            找到 <strong class="text-primary">{{ totalBankruptcyRecords }}</strong> 筆破產記錄
                            <span v-if="unifiedSearchQuery" class="ml-1">
                              ({{ unifiedSearchQuery }})
                            </span>
                          </span>
                        </div>
                      </div>
                      <div v-if="courtCasesRecords.length > 0" class="col-md-6 mb-2">
                        <div class="search-result-compact-court d-flex align-items-center px-3 py-2 rounded">
                          <feather-icon icon="ScaleIcon" size="16" class="text-info mr-2" />
                          <span class="text-muted">
                            找到 <strong class="text-info">{{ totalCourtCasesRecords }}</strong> 筆法院案件
                            <span v-if="unifiedSearchQuery" class="ml-1">
                              ({{ unifiedSearchQuery }})
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                -->

                  <!-- 載入狀態 -->
                  <div v-if="unifiedLoading" class="text-center py-4">
                    <b-spinner variant="primary" class="mr-2"></b-spinner>
                    <span>搜尋中...</span>
                  </div>

                  <!-- 無結果提示 -->
                  <div v-else-if="hasSearched && bankruptcyRecords.length === 0 && courtCasesRecords.length === 0 && !unifiedLoading" class="text-center py-4">
                    <feather-icon icon="SearchIcon" size="48" class="text-muted mb-2" />
                    <h5 class="text-muted">未找到相關記錄</h5>
                    <p class="text-muted">請嘗試使用不同的搜尋條件</p>
                  </div>

                  <!-- 初始狀態 -->
                  <div v-else-if="!hasSearched" class="text-center py-4">
                    <div class="d-flex justify-content-center align-items-center">
                      <feather-icon icon="FileTextIcon" size="32" class="text-primary mr-3" />
                      <feather-icon icon="ScaleIcon" size="32" class="text-info" />
                    </div>
                    <h5 class="text-muted mt-3">破產記錄及法院案件查詢</h5>
                    <p class="text-muted">請輸入姓名、案件編號或當事人進行查詢</p>
                  </div>

                  <!-- 破產記錄表格 -->
                  <div v-if="bankruptcyRecords.length > 0 && !unifiedLoading">
                    <h6 class="text-primary mb-3">
                      <feather-icon icon="FileTextIcon" size="18" class="mr-2" />
                      破產記錄 ({{ totalBankruptcyRecords }} 筆)
                    </h6>
                    <b-table
                      :items="bankruptcyRecords"
                      :fields="bankruptcyTableColumns"
                      responsive
                      striped
                      hover
                      bordered
                      small
                      show-empty
                      empty-text="未找到相關記錄"
                      table-class="bankruptcy-search-table"
                    >
                      <!-- 姓名欄位 -->
                      <template #cell(name)="data">
                        <span class="name-text">{{ data.item.name }}</span>
                      </template>

                      <!-- 英文姓名欄位 -->
                      <template #cell(name_en)="data">
                        <span v-if="data.item.name_en">{{ data.item.name_en }}</span>
                        <span class="text-muted small" v-else>-</span>
                      </template>

                      <!-- 身份證前綴欄位 -->
                      <template #cell(id_prefix)="data">
                        <b-badge variant="secondary">{{ data.item.id_prefix }}</b-badge>
                      </template>

                      <!-- 年份欄位 -->
                      <template #cell(year)="data">
                        <b-badge variant="primary">{{ data.item.year }}年</b-badge>
                      </template>

                      <!-- 案件編號欄位 -->
                      <template #cell(case_number)="data">
                        <span class="text-nowrap">第{{ data.item.case_number }}宗</span>
                      </template>

                      <!-- 公告類型欄位 -->
                      <template #cell(category)="data">
                        <b-badge variant="secondary">法庭命令</b-badge>
                      </template>

                    </b-table>

                    <!-- 破產記錄分頁控制 -->
                    <div v-if="totalBankruptcyRecords > bankruptcyPerPage" class="mt-3 mb-4">
                      <b-pagination
                        v-model="currentBankruptcyPage"
                        :total-rows="totalBankruptcyRecords"
                        :per-page="bankruptcyPerPage"
                        first-number
                        last-number
                        class="justify-content-center"
                        @change="onBankruptcyPageChange"
                      />
                    </div>
                  </div>

                  <!-- 法院案件表格 -->
                  <div v-if="courtCasesRecords.length > 0 && !unifiedLoading">
                    <h6 class="text-info mb-3">
                      <feather-icon icon="ScaleIcon" size="18" class="mr-2" />
                      法院案件 ({{ totalCourtCasesRecords }} 筆)
                    </h6>
                    <b-table
                      :items="courtCasesRecords"
                      :fields="courtCasesTableColumns"
                      responsive
                      striped
                      hover
                      bordered
                      small
                      show-empty
                      empty-text="未找到相關記錄"
                      table-class="court-cases-search-table"
                    >
                      <!-- 案件日期欄位 -->
                      <template #cell(case_date)="data">
                        <b-badge variant="primary">{{ formatDate(data.item.case_date) }}</b-badge>
                      </template>

                      <!-- 案件編號欄位 -->
                      <template #cell(case_number)="data">
                        <strong class="text-primary">{{ data.item.case_number }}</strong>
                      </template>

                      <!-- 案件類型欄位 -->
                      <template #cell(case_type)="data">
                        <b-badge
                          :variant="getCaseTypeVariant(data.item.case_type)"
                          class="text-capitalize case-type-badge"
                        >
                          {{ data.item.case_type }}
                        </b-badge>
                      </template>

                      <!-- 法庭欄位 -->
                      <template #cell(court)="data">
                        <div class="text-wrap">
                          <small class="text-muted">{{ data.item.court_code }}</small><br>
                          {{ data.item.court }}
                        </div>
                      </template>

                      <!-- 法官欄位 -->
                      <template #cell(judge)="data">
                        <span class="font-weight-semibold">{{ data.item.judge || '未指定' }}</span>
                      </template>

                      <!-- 控罪欄位 -->
                      <template #cell(charge)="data">
                        <b-badge variant="secondary">{{ data.item.charge || '未指定' }}</b-badge>
                      </template>

                      <!-- 訴訟各方欄位 -->
                      <template #cell(parties)="data">
                        <div class="text-wrap" style="white-space: pre-wrap; max-width: 300px;">
                          {{ data.item.parties || '未指定' }}
                        </div>
                      </template>

                      <!-- 應訊代表欄位 -->
                      <template #cell(representatives)="data">
                        <div class="text-wrap" style="white-space: pre-wrap; max-width: 300px;">
                          {{ data.item.representatives || '未指定' }}
                        </div>
                      </template>
                    </b-table>

                    <!-- 法院案件分頁控制 -->
                    <div v-if="totalCourtCasesRecords > courtCasesPerPage" class="mt-3">
                      <b-pagination
                        v-model="currentCourtCasesPage"
                        :total-rows="totalCourtCasesRecords"
                        :per-page="courtCasesPerPage"
                        first-number
                        last-number
                        class="justify-content-center"
                        @change="onCourtCasesPageChange"
                      />
                    </div>
                  </div>

                </b-card-body>
              </b-card>
            </b-tab>

      </b-tabs>



    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormCheckbox,
  BOverlay,
  BSpinner,
  BBadge,
  BAlert,
  VBPopover,
  VBTooltip,
  BTabs,
  BTab
} from "bootstrap-vue";
import vSelect from "vue-select";
import { validateID } from "@/libs/idValidator";
import store from "@/store";
import axiosIns from "@/libs/axios";
import ModalPDF from "./modal/ModalPDF";
import ModalSearchForm from "./modal/ModalSearchForm";
import ModalMemberContract from "@/components/ModalMemberContract";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import useSearchsList from "./useSearchsList";
import { mapGetters } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BTable,
    BPagination,
    BFormCheckbox,
    BOverlay,
    BSpinner,
    BBadge,
    BAlert,
    vSelect,
    ModalPDF,
    ModalSearchForm,
    ModalMemberContract,
    BTabs,
    BTab
  },
  directives: {
    "b-popover": VBPopover,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      pdfData: {},
      loading: false,
      // is_detail: 0,
      is_out_of_half_year: 0,
      is_out_of_fifteen_days: 0,
      formTitle: "",
      hkid: "",
      // paySearchQuery: "",
      idError: "",
      number_of_search: 0,
      number_of_loan: 0,
      hasPendingMoneylenderRequest: false,
      // 驗證碼保護相關
      // TEMP DISABLE: 暫時關閉驗證碼保護功能 - 要恢復請改回 true
      showAuthenticatorProtection: false, // 預設顯示驗證碼保護
      authenticatorCode: "",
      verifyingCode: false,
      // TEMP DISABLE: 設為已驗證狀態以繞過驗證
      isAuthenticatorVerified: true, // 原本是 false

      // QR碼確認搜尋相關
      showViewReportModalFlag: false,
      viewReportIdNumber: "",
      showQRCode: false, // 顯示QR碼區域
      showQRConfirmModal: false,
      qrCodeData: null,
      qrPollingInterval: null,
      qrPollingCount: 0,
      maxPollingCount: 150, // 5分鐘 = 150次 * 2秒
      qrConfirmStatus: "pending", // pending, confirmed, expired, error
      qrRefreshInterval: null, // QR碼自動刷新定時器
      qrRefreshCountdown: 15, // QR碼刷新倒計時
      qrRefreshing: false, // QR碼刷新中狀態

      // 防重複提交機制
      processingSearches: new Set(), // 正在處理的身份證號碼
      recentSearches: new Map(), // 最近搜尋的身份證號碼和時間

      // 驗證碼清理定時器
      codeCleanupInterval: null,


      // 暫存的客戶身份證號碼（等驗證成功後填入）
      pendingClientIdNumber: "",
      
      // 最新設定快取
      latestSettings: null,
      settingsLastFetched: null,

      // 驗證碼輸入框高亮特效
      showInputHighlight: false,

      // QR掃描一小時免掃功能
      qrScanValidUntil: null, // QR掃描有效期時間戳
      QR_SCAN_VALIDITY_DURATION: 3600000, // 1小時 = 3600000ms
      // 走馬燈通告功能
      latestAnnouncement: null, // 最新通告內容
      showMarquee: false, // 控制走馬燈顯示
      modalOpening: false, // 防重複觸發modal

      // 破產記錄及法院案件統一搜尋功能
      unifiedSearchQuery: '',
      unifiedLoading: false,
      hasSearched: false,
      unifiedSearchTimeout: null,

      // 破產記錄相關資料
      bankruptcyRecords: [],
      totalBankruptcyRecords: 0,
      currentBankruptcyPage: 1,
      bankruptcyPerPage: 10,

      // 法院案件相關資料
      courtCasesRecords: [],
      totalCourtCasesRecords: 0,
      currentCourtCasesPage: 1,
      courtCasesPerPage: 10,

      // 破產記錄表格欄位定義
      bankruptcyTableColumns: [
        {
          key: 'name',
          label: '姓名',
          sortable: false,
          thStyle: { width: '15%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'name_en',
          label: '英文姓名',
          sortable: false,
          thStyle: { width: '20%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'id_prefix',
          label: '身份證前綴',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '15%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'year',
          label: '年份',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '15%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'case_number',
          label: '案件編號',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '15%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'category',
          label: '公告類型',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '20%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        }
      ],

      // 法院案件表格欄位定義
      courtCasesTableColumns: [
        {
          key: 'case_date',
          label: '案件日期',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '8%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'case_number',
          label: '案件編號',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '12%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'case_type',
          label: '案件類型',
          sortable: false,
          class: 'text-center',
          thClass: 'text-center',
          thStyle: { width: '8%', verticalAlign: 'middle' },
          tdClass: 'align-middle text-center'
        },
        {
          key: 'court',
          label: '法庭',
          sortable: false,
          thStyle: { width: '12%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'judge',
          label: '法官',
          sortable: false,
          thStyle: { width: '10%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'charge',
          label: '控罪',
          sortable: false,
          thStyle: { width: '10%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'parties',
          label: '訴訟各方',
          sortable: false,
          thStyle: { width: '20%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        },
        {
          key: 'representatives',
          label: '應訊代表',
          sortable: false,
          thStyle: { width: '20%', verticalAlign: 'middle' },
          tdClass: 'align-middle'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      get_supplier_info: "app/get_supplier_info",
    }),
    coinBalance() {
      // 使用 Parent ID 的 Coin 餘額
      return this.$store.state.app.user_info &&
        this.$store.state.app.user_info.balance
        ? this.$store.state.app.user_info.balance
        : 0;
    },
    canViewReportDirectly() {
      return this.get_supplier_info && this.get_supplier_info.can_view_report_directly;
    },
    coinExtraSearchRecords() {
      const info = this.latestSettings || (this.$store.state.app.user_info && this.$store.state.app.user_info.info);
      return info
        ? Number(info.coin_extra_search_records) || 0
        : 0;
    },
    coinExtraRecords() {
      const info = this.latestSettings || (this.$store.state.app.user_info && this.$store.state.app.user_info.info);
      return info
        ? Number(info.coin_extra_records) || 0
        : 0;
    },
    // 檢查會員是否過期
    isMembershipExpired() {
      if (!this.get_supplier_info) return false;

      // 公司帳號（company_bit = 1）不檢查會員過期
      if (this.get_supplier_info.company_bit === 1) {
        return false;
      }

      // 獲取當前日期和會員到期日
      const today = new Date();
      const expiryDate = new Date(
        this.get_supplier_info.membership_expiry_date
      );

      // 比較日期，如果當前日期大於會員到期日，則會員已過期
      return today > expiryDate;
    },

    // 檢查放債人牌照是否過期或未設定
    isMoneylenderLicenseExpired() {
      if (!this.get_supplier_info) return false;

      // 公司帳號（company_bit = 1）不檢查放債人牌照過期
      if (this.get_supplier_info.company_bit === 1) {
        return false;
      }

      // 如果沒有設定放債人牌照到期日，視為過期
      if (!this.get_supplier_info.moneylender_license_expiry_date) {
        return true;
      }

      // 獲取當前日期和放債人牌照到期日
      const today = new Date();
      const licenseExpiryDate = new Date(
        this.get_supplier_info.moneylender_license_expiry_date
      );

      // 計算過期天數
      const diffTime = today.getTime() - licenseExpiryDate.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 牌照過期超過3個月（90天）才顯示警告並禁用功能
      return diffDays > 90;
    },

    // 檢查上傳率是否過低且查詢次數超過限制
    isUploadRateDisabled() {
      if (!this.get_supplier_info) return false;
      
      const clientCount = this.get_supplier_info.client_count || 0;
      const validClientsCount = this.get_supplier_info.valid_client_count || 0;
      
      // 如果查詢次數 > 50 且上傳率 < 30%，則停用功能
      if (clientCount > 50) {
        const uploadRate = clientCount === 0 ? 0 : (validClientsCount / clientCount);
        return uploadRate < 0.3;
      }
      
      return false;
    },

    // 搜尋費用計算
    searchCostCalculation() {
      // 優先使用最新獲取的設定，如果沒有則使用 store 中的數據
      const tem = this.latestSettings || (this.$store.state.app.user_info && this.$store.state.app.user_info.info);
      if (!tem) {
        return {
          freeSearchToUse: 0,
          coinNeeded: 0,
          basicSearchCost: 0,
        };
      }
      const searchLimitAvailable = this.get_supplier_info
        ? this.get_supplier_info.search_limit || 0
        : 0;

      // 計算需要的搜尋次數
      let searchLimitNeeded = 1; // 基本搜尋
      if (this.is_out_of_half_year) {
        searchLimitNeeded += 1;
      }
      if (this.is_out_of_fifteen_days) {
        searchLimitNeeded += 1;
      }

      // 計算使用的免費搜尋次數
      const freeSearchToUse = Math.min(searchLimitAvailable, searchLimitNeeded);
      const remainingSearches = searchLimitNeeded - freeSearchToUse;

      // 計算需要的 X Coin
      let coinNeeded = 0;
      let basicSearchCost = 0;

      if (remainingSearches > 0) {
        // 基本搜尋費用
        if (freeSearchToUse === 0) {
          basicSearchCost = Number(tem.coin_per_search) || 0;
          coinNeeded += basicSearchCost;
        }

        // 額外選項費用
        if (this.is_out_of_half_year) {
          coinNeeded += Number(tem.coin_extra_records) || 0;
        }
        if (this.is_out_of_fifteen_days) {
          coinNeeded += Number(tem.coin_extra_search_records) || 0;
        }
      }

      return {
        freeSearchToUse,
        coinNeeded,
        basicSearchCost,
        searchLimitNeeded,
        remainingSearches,
      };
    },

    // 獲取半年外個人財務狀況費用
    getCoinExtraRecords() {
      const info = this.latestSettings || (this.$store.state.app.user_info && this.$store.state.app.user_info.info);
      return info ? (Number(info.coin_extra_records) || 0) : 0;
    },

    // 獲取15日以外查詢紀錄費用
    getCoinExtraSearchRecords() {
      const info = this.latestSettings || (this.$store.state.app.user_info && this.$store.state.app.user_info.info);
      return info ? (Number(info.coin_extra_search_records) || 0) : 0;
    },

    // QR碼數據字符串（用於調試）
    qrCodeDataString() {
      if (this.qrCodeData) {
        try {
          return JSON.stringify(this.qrCodeData);
        } catch (e) {
          return "JSON stringify error";
        }
      }
      return "No QR data";
    },
  },
  methods: {
    // =================================
    // 破產記錄及法院案件統一搜尋功能
    // =================================

    // 搜尋輸入處理（防抖動）
    onUnifiedSearchInput() {
      if (this.unifiedSearchTimeout) {
        clearTimeout(this.unifiedSearchTimeout)
      }
    },

    // 執行統一搜尋
    async searchUnifiedRecords() {
      if (!this.unifiedSearchQuery.trim()) {
        this.$bvToast.toast('請輸入搜尋關鍵字', {
          title: '提示',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.unifiedLoading = true
      this.hasSearched = true

      // 同時搜尋破產記錄和法院案件
      const searchPromises = [
        this.searchBankruptcyRecords(),
        this.searchCourtCasesRecords()
      ]

      try {
        // 使用 Promise.allSettled 確保即使一個 API 失敗，另一個仍能正常顯示
        const results = await Promise.allSettled(searchPromises)

        // 記錄失敗的搜尋
        const failures = results.filter(result => result.status === 'rejected')

        if (failures.length > 0) {
          console.warn('部分搜尋 API 失敗:', failures)
        }

        // 如果兩個 API 都失敗，顯示錯誤訊息
        if (failures.length === 2) {
          this.$bvToast.toast('搜尋服務暫時不可用，請稍後再試', {
            title: '錯誤',
            variant: 'danger',
            solid: true
          })
        }

      } catch (error) {
        console.error('Unified search error:', error)
        this.$bvToast.toast('搜尋失敗，請重試', {
          title: '錯誤',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.unifiedLoading = false
      }
    },

    // 搜尋破產記錄
    async searchBankruptcyRecords() {
      try {
        const token = localStorage.getItem('accessToken')
        const params = {
          q: this.unifiedSearchQuery.trim(),
          perPage: this.bankruptcyPerPage,
          page: this.currentBankruptcyPage,
          sortBy: 'created_at',
          sortDesc: 1
        }

        const response = await axiosIns.get(
          `${process.env.VUE_APP_SERVICE_URL}/bankruptcy/list`,
          {
            params,
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        )

        if (response.data.success) {
          this.bankruptcyRecords = response.data.data || []
          this.totalBankruptcyRecords = response.data.total || 0
        } else {
          throw new Error(response.data.message || '破產記錄查詢失敗')
        }

      } catch (error) {
        console.error('Bankruptcy search error:', error)
        this.bankruptcyRecords = []
        this.totalBankruptcyRecords = 0
        throw error // 重新拋出錯誤以便統一處理
      }
    },

    // 搜尋法院案件
    async searchCourtCasesRecords() {
      try {
        const token = localStorage.getItem('accessToken')
        const params = {
          q: this.unifiedSearchQuery.trim(),
          perPage: this.courtCasesPerPage,
          page: this.currentCourtCasesPage,
          sortBy: 'case_date',
          sortDesc: 1
        }

        const response = await axiosIns.get(
          `${process.env.VUE_APP_SERVICE_URL}/court-cases/list`,
          {
            params,
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        )

        if (response.data.success) {
          this.courtCasesRecords = response.data.data || []
          this.totalCourtCasesRecords = response.data.total || 0
        } else {
          throw new Error(response.data.message || '法院案件查詢失敗')
        }

      } catch (error) {
        console.error('Court cases search error:', error)

        // 如果是 404 錯誤，表示 API 還未實作
        if (error.response && error.response.status === 404) {
          console.warn('法院案件 API 尚未實作')
          this.courtCasesRecords = []
          this.totalCourtCasesRecords = 0
          // 不拋出錯誤，讓破產記錄能正常顯示
          return
        }

        this.courtCasesRecords = []
        this.totalCourtCasesRecords = 0
        throw error // 重新拋出其他錯誤
      }
    },

    // 清除搜尋
    clearUnifiedSearch() {
      this.unifiedSearchQuery = ''
      this.bankruptcyRecords = []
      this.courtCasesRecords = []
      this.totalBankruptcyRecords = 0
      this.totalCourtCasesRecords = 0
      this.currentBankruptcyPage = 1
      this.currentCourtCasesPage = 1
      this.hasSearched = false
      if (this.unifiedSearchTimeout) {
        clearTimeout(this.unifiedSearchTimeout)
      }
    },

    // 破產記錄分頁處理
    onBankruptcyPageChange(page) {
      this.currentBankruptcyPage = page
      this.searchBankruptcyRecords()
    },

    // 法院案件分頁處理
    onCourtCasesPageChange(page) {
      this.currentCourtCasesPage = page
      this.searchCourtCasesRecords()
    },


    // 格式化日期
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('zh-TW')
    },

    // 取得案件類型樣式
    getCaseTypeVariant(type) {
      const variants = {
        '刑事': 'danger',
        '民事': 'primary',
        '商事': 'success',
        '家事': 'info',
        '上訴': 'warning',
        '覆核': 'secondary'
      }
      return variants[type] || 'light'
    },

    // =================================
    // 原有功能方法
    // =================================

    // 處理放債人牌照操作按鈕
    handleMoneylenderLicenseAction() {
      // 直接打開modal，不顯示確認對話框
      this.$bvModal.show("modal-edit-moneylender-number");
    },
    // 獲取最新通告
    async fetchLatestAnnouncement() {
      try {
        const response = await axiosIns.get("/blog/marquee");
        if (response.data && response.data.blogs && response.data.blogs.length > 0) {
          this.latestAnnouncement = response.data.blogs[0];
          this.showMarquee = true;
        } else {
          this.showMarquee = false;
        }
      } catch (error) {
        console.error("獲取走馬燈通告失敗:", error);
        this.showMarquee = false;
      }
    },
    // 將 HTML 轉換為純文字
    htmlToText(html) {
      if (!html) return "";
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    // 點擊走馬燈顯示通告列表 modal
    showAnnouncementModal(event) {
      // 防止事件冒泡
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      // 防重複觸發
      if (this.modalOpening) return;
      this.modalOpening = true;
      
      this.$bvModal.show('modal-blog-list');
      
      // 延遲重置防重複標記
      setTimeout(() => {
        this.modalOpening = false;
      }, 500);
    },

    // 檢查是否有未處理的放債人牌照申請（只設置狀態，不彈出提示）
    checkPendingMoneylenderRequest() {
      axiosIns.get("/supplier_change_request/check-pending")
        .then(response => {
          this.hasPendingMoneylenderRequest = response.data.hasPending;
        })
        .catch(error => {
          console.error("Failed to check pending request:", error);
          this.hasPendingMoneylenderRequest = false;
        });
    },

    // 格式化新活動詳情文本
    getActivityDetailsText(activityDetails) {
      if (!activityDetails || activityDetails.length === 0) {
        return "無詳細信息";
      }

      return activityDetails
        .map((detail) => `${detail.description}: ${detail.count}筆`)
        .join("\n");
    },

    // 處理新活動按鈕點擊
    handleNewActivityClick(searchRecord) {
      // TEMP DISABLE: 直接填入身份證號碼並觸發搜尋
      this.searchQuery = searchRecord.client.id_number;
      
      /* 原始驗證碼邏輯（已關閉）
      // 暫存身份證號碼，等驗證成功後再填入
      this.pendingClientIdNumber = searchRecord.client.id_number;

      // TEMP DISABLE: 暫時關閉安全驗證碼保護
      // this.showAuthenticatorProtection = true; // 原始邏輯
      this.showAuthenticatorProtection = false; // 暫時關閉
      this.isAuthenticatorVerified = true; // 設為已驗證狀態
      this.authenticatorCode = "";
      */

      // 滾動到驗證碼區域並觸發輸入框特效
      this.$nextTick(() => {
        const authSection = document.querySelector(".card.border-primary");
        if (authSection) {
          authSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        // 延遲觸發輸入框特效
        setTimeout(() => {
          this.showInputHighlight = true;
          // 4.5秒後移除特效（3次動畫 * 1.5秒）
          setTimeout(() => {
            this.showInputHighlight = false;
          }, 4500);
        }, 500);
      });

      // 顯示toast提示信息
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: `新活動檢測`,
          icon: "AlertTriangleIcon",
          variant: "info",
          text: `檢測到身份證號碼 ${searchRecord.client.id_number} 有新活動，正在執行搜尋更新報告...`,
        },
      });
      
      // 稍待一下再觸發搜尋，讓使用者看到身份證號碼填入
      this.$nextTick(() => {
        setTimeout(() => {
          this.triggerSearchConfirm();
        }, 800);
      });
    },

    // Token顯示（用於調試）
    getTokenDisplay() {
      if (this.qrCodeData && this.qrCodeData.token) {
        return this.qrCodeData.token.substring(0, 10) + "...";
      }
      return "N/A";
    },

    triggerModalMemberContract() {
      this.$bvModal.show("modal-member-contract");
    },
    triggerModalSearchForm() {
      this.$bvModal.show("modal-search-form");
    },

    checkPendingRequestAndShowModal(licenseMessage) {
      // 檢查是否有未批准的記錄（只設置狀態，不彈出modal）
      axiosIns.get("/supplier_change_request/check-pending")
        .then(response => {
          if (response.data.hasPending) {
            // 有未處理的申請，設置狀態但不彈出提示
            this.hasPendingMoneylenderRequest = true;
          } else {
            // 沒有未處理的申請，設置狀態但不彈出modal
            this.hasPendingMoneylenderRequest = false;
          }
        })
        .catch(error => {
          console.error("Failed to check pending request:", error);
          this.hasPendingMoneylenderRequest = false;
        });
    },

    // 驗證碼相關方法
    onAuthenticatorCodeInput(value) {
      // 只允許數字輸入
      this.authenticatorCode = value.replace(/\D/g, "");
    },

    async verifyAuthenticatorCode() {
      if (this.authenticatorCode.length !== 6) {
        this.$swal({
          text: "請輸入6位驗證碼",
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      this.verifyingCode = true;

      try {
        // 第一步：嘗試前端本地驗證
        let isValid = false;

        try {
          // 獲取緩存的密鑰進行本地驗證
          const cachedSecret = localStorage.getItem("supplier_auth_secret");
          const cacheTime = localStorage.getItem("supplier_auth_secret_time");

          if (cachedSecret && cacheTime) {
            const now = Date.now();
            const cached = parseInt(cacheTime);
            if (now - cached < 24 * 60 * 60 * 1000) {
              // 24小時內有效
              isValid = this.verifyTOTPLocally(
                this.authenticatorCode,
                cachedSecret
              );
            }
          }
        } catch (localError) {
          // 本地驗證失敗，繼續嘗試重新獲取密鑰
        }

        // 第二步：如果本地驗證失敗，嘗試重新獲取密鑰並驗證
        if (!isValid) {
          try {
            // 清除舊緩存
            localStorage.removeItem("supplier_auth_secret");
            localStorage.removeItem("supplier_auth_secret_time");

            // 重新獲取密鑰
            const secretKey = await this.getSupplierSecretKey();
            if (secretKey) {
              isValid = this.verifyTOTPLocally(
                this.authenticatorCode,
                secretKey
              );
            }
          } catch (refreshError) {
            // 重新獲取密鑰失敗
          }
        }

        // 驗證結果處理
        if (isValid) {
          this.isAuthenticatorVerified = true;
          this.showAuthenticatorProtection = false;
          this.authenticatorCode = "";

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CoffeeIcon",
              variant: "success",
              text: `驗證成功！`,
            },
          });

          // 如果有暫存的身份證號碼，填入並觸發搜尋確認
          if (this.pendingClientIdNumber) {
            this.searchQuery = this.pendingClientIdNumber;
            this.pendingClientIdNumber = ""; // 清空暫存

            this.$nextTick(() => {
              this.triggerSearchConfirm();
            });
          }
          // 如果沒有暫存但有搜尋查詢，也觸發搜尋確認
          else if (this.searchQuery) {
            this.$nextTick(() => {
              this.triggerSearchConfirm();
            });
          }
        } else {
          throw new Error("驗證碼錯誤或已被使用");
        }
      } catch (error) {
        console.error("驗證過程中發生錯誤:", error);

        let errorMessage = "驗證碼錯誤或已被使用";

        if (error.response) {
          // 獲取密鑰時的服務器錯誤
          if (error.response.status === 401) {
            errorMessage = "用戶未認證，請重新登入";
          } else if (error.response.status === 404) {
            errorMessage = "驗證密鑰不存在，請重新綁定設備";
          } else {
            errorMessage = "無法獲取驗證密鑰，請重新綁定設備";
          }
        } else if (error.request) {
          errorMessage = "網絡錯誤，請檢查連接";
        } else {
          errorMessage = error.message || "驗證過程中發生錯誤";
        }

        this.$swal({
          text: errorMessage,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });

        // 驗證失敗時清空暫存的身份證號碼
        this.pendingClientIdNumber = "";
      } finally {
        this.verifyingCode = false;
      }
    },

    // 獲取供應商密鑰
    async getSupplierSecretKey() {
      try {
        // 檢查認證狀態
        //console.log('檢查認證狀態...');
        //console.log('用戶信息:', this.$store.state.app.user_info);
        //console.log('JWT 令牌:', localStorage.getItem('accessToken'));

        // 先檢查本地存儲
        const cachedSecret = localStorage.getItem("supplier_auth_secret");
        const cacheTime = localStorage.getItem("supplier_auth_secret_time");

        // 如果有緩存且未過期（24小時），直接使用
        if (cachedSecret && cacheTime) {
          const now = Date.now();
          const cached = parseInt(cacheTime);
          if (now - cached < 24 * 60 * 60 * 1000) {
            // 24小時
            //console.log('使用緩存的供應商密鑰');
            return cachedSecret;
          }
        }

        //console.log('從後端獲取供應商密鑰...');

        // 從後端獲取密鑰（使用 JWT 認證的路由）
        const response = await axiosIns.get("/authenticator/secret-legacy");

        if (response.data.success) {
          const secretKey = response.data.data.secret_key;

          //console.log('成功獲取供應商密鑰:', secretKey);

          // 緩存密鑰
          localStorage.setItem("supplier_auth_secret", secretKey);
          localStorage.setItem(
            "supplier_auth_secret_time",
            Date.now().toString()
          );

          return secretKey;
        } else {
          throw new Error(response.data.message || "獲取密鑰失敗");
        }
      } catch (error) {
        console.error("獲取供應商密鑰失敗：", error);

        // 顯示錯誤提示
        this.$swal({
          text: "無法獲取驗證密鑰，請確保已登入並重試",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });

        return null;
      }
    },

    // 本地驗證 TOTP 碼（改進版：縮短容錯時間並防重複使用）
    verifyTOTPLocally(code, secretKey, timeWindow = 30, tolerance = 0) {
      // 檢查驗證碼是否已被使用
      if (this.isCodeAlreadyUsed(code)) {
        return false;
      }

      // 縮短容錯時間窗口：tolerance = 0 表示只檢查當前時間窗口
      // 這樣驗證碼只在30秒內有效，而不是90秒
      for (let i = -tolerance; i <= tolerance; i++) {
        const timeCounter = Math.floor(Date.now() / 1000 / timeWindow) + i;
        const expectedCode = this.generateTOTPCode(secretKey, timeCounter);

        if (code === expectedCode) {
          // 記錄驗證碼使用
          this.recordCodeUsage(code, timeCounter);
          return true;
        }
      }

      return false;
    },

    // 檢查驗證碼是否已被使用
    isCodeAlreadyUsed(code) {
      const usedCodes = JSON.parse(
        localStorage.getItem("used_totp_codes") || "[]"
      );
      const now = Date.now();

      // 清理過期記錄（超過2分鐘的記錄）
      const validCodes = usedCodes.filter(
        (item) => now - item.timestamp < 120000
      );

      // 檢查當前驗證碼是否已使用
      const isUsed = validCodes.some((item) => item.code === code);

      // 更新本地存儲
      localStorage.setItem("used_totp_codes", JSON.stringify(validCodes));

      return isUsed;
    },

    // 記錄驗證碼使用
    recordCodeUsage(code, timeCounter) {
      const usedCodes = JSON.parse(
        localStorage.getItem("used_totp_codes") || "[]"
      );

      // 添加新記錄
      usedCodes.push({
        code: code,
        timeCounter: timeCounter,
        timestamp: Date.now(),
      });

      // 只保留最近2分鐘的記錄
      const now = Date.now();
      const validCodes = usedCodes.filter(
        (item) => now - item.timestamp < 120000
      );

      localStorage.setItem("used_totp_codes", JSON.stringify(validCodes));
    },

    // 清理過期的驗證碼記錄
    cleanupExpiredCodes() {
      try {
        const usedCodes = JSON.parse(
          localStorage.getItem("used_totp_codes") || "[]"
        );
        const now = Date.now();

        // 清理超過2分鐘的記錄
        const validCodes = usedCodes.filter(
          (item) => now - item.timestamp < 120000
        );

        // 如果有記錄被清理，更新本地存儲
        if (validCodes.length !== usedCodes.length) {
          localStorage.setItem("used_totp_codes", JSON.stringify(validCodes));
        }

        // 檢查並清理過期的QR掃描記錄
        const qrValidUntil = localStorage.getItem('qrScanValidUntil');
        if (qrValidUntil && now >= parseInt(qrValidUntil)) {
          // QR掃描記錄已過期，清理它
          localStorage.removeItem('qrScanValidUntil');
          this.qrScanValidUntil = null;
          console.log('已清理過期的QR掃描記錄');
        }

      } catch (error) {
        // 如果出錯，清空所有記錄
        localStorage.removeItem("used_totp_codes");
        localStorage.removeItem("qrScanValidUntil"); // 同時清理QR掃描記錄
        this.qrScanValidUntil = null;
      }
    },

    // 清理QR掃描緩存（登出時使用）
    clearQRScanCache() {
      try {
        // 清理前端狀態
        this.qrScanValidUntil = null;
        
        // 清理localStorage中的QR掃描記錄
        localStorage.removeItem('qrScanValidUntil');
        
        console.log('已清理QR掃描緩存');
      } catch (error) {
        console.error('清理QR掃描緩存時發生錯誤:', error);
      }
    },

    // 🔧 恢復QR掃描狀態（頁面初始化時使用）
    restoreQRScanState() {
      try {
        const storedValidUntil = localStorage.getItem('qrScanValidUntil');
        if (storedValidUntil) {
          const validUntil = parseInt(storedValidUntil);
          const now = Date.now();
          
          if (now < validUntil) {
            // QR掃描仍在有效期內
            this.qrScanValidUntil = validUntil;
            console.log('恢復QR掃描狀態，有效期至:', new Date(validUntil).toLocaleString());
          } else {
            // QR掃描已過期，清理記錄
            localStorage.removeItem('qrScanValidUntil');
            this.qrScanValidUntil = null;
            console.log('QR掃描記錄已過期，已清理');
          }
        }
      } catch (error) {
        console.error('恢復QR掃描狀態時發生錯誤:', error);
        // 出錯時清理可能損壞的記錄
        localStorage.removeItem('qrScanValidUntil');
        this.qrScanValidUntil = null;
      }
    },

    // 生成 TOTP 碼（標準 Google 2FA 算法）
    generateTOTPCode(secretKey, timeCounter) {
      // 標準 TOTP 算法：不應該在生成時使用當前時間戳
      // 只使用 secretKey 和 timeCounter
      const input = secretKey + timeCounter.toString();
      const code = this.simpleHash(input); // simpleHash 現在直接返回6位驗證碼

      return code;
    },

    // 簡單哈希函數（與 UniApp 保持一致）
    simpleHash(input) {
      // 使用更好的哈希函數，確保良好的分佈性（與 UniApp 一致）
      let hash = 0;

      // 第一輪：基本哈希
      for (let i = 0; i < input.length; i++) {
        hash = (hash << 5) - hash + input.charCodeAt(i);
        hash |= 0; // 轉換為 32 位整數
      }

      // 第二輪：添加更多混淆
      hash = hash ^ (hash >>> 16);
      hash = (hash * 0x85ebca6b) | 0;
      hash = hash ^ (hash >>> 13);
      hash = (hash * 0xc2b2ae35) | 0;
      hash = hash ^ (hash >>> 16);

      // 確保為正數
      hash = Math.abs(hash);

      // 使用模運算確保6位數字的良好分佈
      const code = (hash % 1000000).toString().padStart(6, "0");

      return code;
    },

    showAuthenticatorAlert() {
      this.$swal({
        text: "請先從手機APP取得驗證碼並完成驗證",
        icon: "warning",
        confirmButtonText: "確定",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    // 重置驗證碼保護狀態
    resetAuthenticatorProtection(clearQRCache = false) {
      // TEMP DISABLE: 暫時關閉驗證碼保護
      // this.showAuthenticatorProtection = true; // 原始邏輯
      this.showAuthenticatorProtection = false; // 暫時關閉
      // this.isAuthenticatorVerified = false; // 原始邏輯
      this.isAuthenticatorVerified = true; // 設為已驗證狀態
      this.authenticatorCode = "";
      this.pendingClientIdNumber = ""; // 清空暫存的身份證號碼

      // 🔧 只在明確指定時才清理QR掃描緩存（避免破壞一小時免掃功能）
      if (clearQRCache) {
        this.clearQRScanCache();
      }

      // 清理已使用的驗證碼記錄，防止累積過多記錄
      this.cleanupExpiredCodes();
    },

    // 測試方法：生成當前時間窗口的驗證碼
    testGenerateCurrentCode() {
      const secretKey = "TESTSUPPLIERKEY123456789012345";
      const timeCounter = Math.floor(Date.now() / 1000 / 30);
      const code = this.generateTOTPCode(secretKey, timeCounter);

      return code;
    },
    triggerSearchConfirm() {
      // 防重複提交檢查
      if (this.checkDuplicateSubmission()) {
        return;
      }

      this.loading = true;

      this.IsHKID(this.searchQuery);

      store
        .dispatch("app/checkNumberOfRecord", { q: this.searchQuery })
        .then((response) => {
          this.loading = false;
          let msg = "";
          let tem = this.latestSettings || this.$store.state.app.user_info.info;
          let searchLimitAvailable = this.get_supplier_info.search_limit || 0;
          let searchLimitNeeded = 1;
          let coinNeeded = 0;

          // 計算需要的搜尋次數和 Coin
          if (this.is_out_of_half_year) {
            searchLimitNeeded += 1;
          }

          if (this.is_out_of_fifteen_days) {
            searchLimitNeeded += 1;
          }

          // 檢查是否有15天內的搜尋記錄
          if (response.data.number_of_records >= 1) {
            // 檢查是否有新活動
            if (response.data.has_new_activity) {
              // 有新活動，需要重新付款搜尋
              msg += `系統檢查該身分證號碼已於15天內搜尋 ${response.data.number_of_records} 次，但檢測到有新活動，需要重新付款搜尋以獲得最新報告。`;
            } else {
              // 沒有新活動，可以使用過往記錄
              msg += `系統檢查該身分證號碼已於15天內搜尋
                ${response.data.number_of_records}
                次，請到過往搜尋記錄中取得報告`;
            }
          } else {
            // 計算混合支付方式
            let searchLimitToUse = Math.min(
              searchLimitAvailable,
              searchLimitNeeded
            );
            let remainingSearches = searchLimitNeeded - searchLimitToUse;

            // 計算需要的 Coin
            if (remainingSearches > 0) {
              // 基本搜尋
              if (searchLimitToUse === 0) {
                coinNeeded += Number(tem.coin_per_search);
              }

              // 額外選項 - 修正計算邏輯
              // 如果選擇了半年外個人財務狀況，且免費搜尋次數不足以支付
              if (this.is_out_of_half_year) {
                coinNeeded += Number(tem.coin_extra_records);
              }

              // 如果選擇了15日以外查詢紀錄，且免費搜尋次數不足以支付
              if (this.is_out_of_fifteen_days) {
                coinNeeded += Number(tem.coin_extra_search_records);
              }
            }

            // 檢查 Coin 餘額是否足夠
            if (coinNeeded > 0 && this.coinBalance < coinNeeded) {
              msg += `你的免費搜尋次數不足，需要額外 ${coinNeeded} X Coin，但你的 X Coin 餘額不足`;
              this.$swal({
                text: msg,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              return;
            }

            // 🔧 修復：強制所有搜尋都通過QR碼確認，防止bypass
            // 顯示QR碼確認區域而不是傳統確認對話框
            this.showQRConfirmSection();
            return;
          }

          // 🔧 修復：移除舊的 isVaild 函數，防止bypass QR碼確認
          // 所有搜尋現在都必須通過QR碼確認流程，不再需要 isVaild 函數

          if (!this.idError) {
            // 判斷是否需要顯示確認對話框
            const hasRecordsButNoNewActivity =
              response.data.number_of_records >= 1 &&
              !response.data.has_new_activity;
            const hasNewActivity =
              response.data.number_of_records >= 1 &&
              response.data.has_new_activity;

            this.$swal({
              title: "",
              width: response.data.number_of_records >= 1 ? "670px" : "auto",
              html: msg,
              showCancelButton: true,
              confirmButtonText: hasNewActivity ? "購買更新報告" : "確定",
              cancelButtonText: "取消",
              showCancelButton: hasRecordsButNoNewActivity ? false : true,
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-danger ml-1",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.value) {
                // 🔧 修復：所有情況都強制使用QR碼確認，防止bypass
                if (response.data.number_of_records < 1) {
                  // 原本會調用 isVaild()，現在強制使用QR碼確認
                  this.showQRConfirmSection();
                }
                // 如果有新活動且用戶選擇購買更新報告，直接顯示QR碼確認
                else if (hasNewActivity) {
                  this.showQRConfirmSection();
                }
              }
            });
          } else {
            // 🔧 修復：身份證驗證錯誤時也強制使用QR碼確認，防止bypass
            // 原本會調用 isVaild()，現在強制使用QR碼確認
            this.showQRConfirmSection();
          }
        })
        .catch((error) => {
          this.loading = false;

          // 標記搜尋失敗
          this.markSearchFailed(this.searchQuery);

          console.log(error);
          this.$swal({
            text: JSON.stringify(error.response.data.message),
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    async handleDownload(key_words) {
      this.loading = true;
      
      // 在搜尋前獲取最新設定，確保收費計算正確
      await this.fetchLatestSettings();
      let is_detail = this.is_detail;
      if (isNaN(is_detail)) {
        is_detail ? (is_detail = 1) : (is_detail = 0);
      }

      // 計算混合支付方式
      let searchLimitAvailable = this.get_supplier_info.search_limit || 0;
      let searchLimitNeeded = 1;

      // 計算需要的搜尋次數
      if (this.is_out_of_half_year) {
        searchLimitNeeded += 1;
      }
      if (this.is_out_of_fifteen_days) {
        searchLimitNeeded += 1;
      }

      // 計算實際使用的搜尋次數和剩餘需要 Coin 支付的部分
      let searchLimitToUse = Math.min(searchLimitAvailable, searchLimitNeeded);
      let useCoins = searchLimitToUse < searchLimitNeeded;

      // 計算需要的 X Coin
      let tem = this.latestSettings || this.$store.state.app.user_info.info;
      let coinNeeded = 0;

      // 如果需要使用 X Coin
      if (useCoins) {
        // 如果沒有免費搜尋次數，需要使用 X Coin 支付基本搜尋
        if (searchLimitToUse === 0) {
          coinNeeded += Number(tem.coin_per_search);
        }

        // 額外選項
        if (this.is_out_of_half_year) {
          coinNeeded += Number(tem.coin_extra_records);
        }

        if (this.is_out_of_fifteen_days) {
          coinNeeded += Number(tem.coin_extra_search_records);
        }
      }

      // 更新搜尋參數
      let params = {
        search_record_id: key_words,
        q: key_words,
        all_record_bit: this.is_out_of_half_year,
        all_search_record_bit: this.is_out_of_fifteen_days,
        search_limit_to_use: searchLimitToUse, // 添加實際使用的搜尋次數
        use_mixed_payment: useCoins && searchLimitToUse > 0, // 是否使用混合支付
        coin_needed: coinNeeded, // 添加需要的 X Coin 數量
      };

      axiosIns
        .get("/record/search", {
          params: params,
        })
        .then((response) => {
          // 搜尋成功後先調用 updateSnapshot 確保數據完整性
          const searchRecordId = response.data.search_record.id;

          return this.$store
            .dispatch("app/updateSearchRecordSnapshot", {
              search_record_id: searchRecordId,
            })
            .then((updateResponse) => {
              console.log("搜尋後快照更新成功", updateResponse.data);

              // 快照更新成功後，使用更新後的數據
              if (updateResponse.data.search_record) {
                this.pdfData = updateResponse.data.search_record;
                this.number_of_search = updateResponse.data.number_of_search;
                this.number_of_loan = updateResponse.data.number_of_loan;
              } else {
                // 如果更新失敗，使用原始數據
                this.pdfData = response.data.search_record;
                this.number_of_loan = response.data.number_of_loan;
                this.number_of_search = response.data.number_of_search;
              }

              this.loading = false;
              this.$store.dispatch("app/fetchCoinsBalance");
              this.fetchSuppliersInfo();

              // 數據準備完成後才打開 modal
              this.$bvModal.show("modal-PDF");
              this.$swal({
                text: response.data.message,
                confirmButtonText: "確定",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              // 搜尋成功後重新顯示驗證碼保護
              this.resetAuthenticatorProtection();
            })
            .catch((updateError) => {
              console.log("快照更新失敗，使用原始數據", updateError);

              // 如果快照更新失敗，使用原始搜尋結果
              this.pdfData = response.data.search_record;
              this.number_of_loan = response.data.number_of_loan;
              this.number_of_search = response.data.number_of_search;

              this.loading = false;
              this.$store.dispatch("app/fetchCoinsBalance");
              this.fetchSuppliersInfo();

              // 數據準備完成後才打開 modal
              this.$bvModal.show("modal-PDF");
              this.$swal({
                text: response.data.message,
                confirmButtonText: "確定",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              // 搜尋成功後重新顯示驗證碼保護
              this.resetAuthenticatorProtection();

              // 重新獲取搜尋記錄列表
              this.refetchData();
            });
        })
        .catch(async (error) => {
          this.loading = false;
          let responseObj = error.response.data;

          // 標記搜尋失敗
          this.markSearchFailed(key_words);

          this.refetchData();
          if (responseObj.client_not_exists) {
            this.formTitle = responseObj.message;
            this.triggerModalSearchForm();
            this.hkid = key_words;
          } else {
            // 檢查是否為放債人牌照相關錯誤 (已禁用)
            // if (responseObj.message && 
            //     (responseObj.message.includes("放債人牌照") || 
            //      responseObj.message.includes("moneylender") ||
            //      responseObj.message.includes("license"))) {
            //   
            //   // 先檢查是否有未批准的記錄
            //   this.checkPendingRequestAndShowModal(responseObj.message);
            // } else {
            // 一般錯誤處理
              this.$swal({
                text: responseObj.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            // }
            this.$bvModal.hide("modal-PDF");
          }
        });
    },
    triggerModalSearchInfo(id) {
      this.loading = true;

      // 先調用 updateSnapshot API
      this.$store
        .dispatch("app/updateSearchRecordSnapshot", {
          search_record_id: id,
        })
        .then((updateResponse) => {
          console.log("快照更新成功", updateResponse.data);

          // 快照更新成功後，再調用 fetchNewestDashboardSearchRecord
          return this.$store.dispatch("app/fetchNewestDashboardSearchRecord", {
            id: id,
          });
        })
        .then((response) => {
          this.loading = false;
          this.number_of_loan = response.data.number_of_loan;
          this.number_of_search = response.data.number_of_search;
          this.pdfData = response.data.search_record;
          this.$bvModal.show("modal-PDF");
        })
        .catch((error) => {
          this.loading = false;
          console.log("錯誤:", error);

          // 如果 updateSnapshot 失敗，嘗試直接調用 fetchNewestDashboardSearchRecord
          if (error.response && error.response.status === 403) {
            // 權限問題，直接調用原始 API
            this.$store
              .dispatch("app/fetchNewestDashboardSearchRecord", { id: id })
              .then((response) => {
                this.loading = false;
                this.number_of_loan = response.data.number_of_loan;
                this.number_of_search = response.data.number_of_search;
                this.pdfData = response.data.search_record;
                this.$bvModal.show("modal-PDF");
              })
              .catch((fallbackError) => {
                this.loading = false;
                this.$swal({
                  text: JSON.stringify(fallbackError.response.data.message),
                  icon: "error",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              });
          } else {
            // 其他錯誤
            this.$swal({
              text: JSON.stringify(
                error.response?.data?.message || error.message
              ),
              icon: "error",
              confirmButtonText: "確定",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
            });
          }
        });
    },
    
    showViewReportModal() {
      this.viewReportIdNumber = "";
      this.showViewReportModalFlag = true;
    },
    
    viewReportByIdNumber() {
      if (!this.viewReportIdNumber) {
        this.$swal({
          text: "請輸入身分證號碼",
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
        return;
      }
      
      this.loading = true;
      this.showViewReportModalFlag = false;
      
      // 調用新的 API endpoint
      this.$store
        .dispatch("app/fetchSearchRecordByIdNumber", {
          id_number: this.viewReportIdNumber,
        })
        .then((response) => {
          this.loading = false;
          if (response.data && response.data.search_record) {
            this.number_of_loan = response.data.number_of_loan;
            this.number_of_search = response.data.number_of_search;
            this.pdfData = response.data.search_record;
            this.$bvModal.show("modal-PDF");
          } else {
            this.$swal({
              text: "找不到相關報告",
              icon: "info",
              confirmButtonText: "確定",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              showClass: {
                popup: "animate__animated animate__bounceIn",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            text: error.response?.data?.message || "查詢報告時發生錯誤",
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },

    // 統一證件驗證（香港 + 澳門），詳見 @/libs/idValidator
    IsHKID(str) {
      if (validateID(str)) {
        this.idError = "";
        return true;
      }
      this.idError = "證件號碼" + str + "不正確";
      return false;
    },

    // 防重複提交相關方法
    checkDuplicateSubmission() {
      const searchId = this.searchQuery.trim().toUpperCase();

      if (!searchId) {
        return false;
      }

      // 檢查是否正在處理中
      if (this.processingSearches.has(searchId)) {
        this.$swal({
          text: `身份證號碼 ${searchId} 正在處理中，請等待完成後再試`,
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return true;
      }

      // 檢查最近搜尋記錄（5分鐘內）
      const now = Date.now();
      const recentSearchTime = this.recentSearches.get(searchId);

      if (recentSearchTime && now - recentSearchTime < 300000) {
        // 5分鐘 = 300000毫秒
        const remainingTime = Math.ceil(
          (300000 - (now - recentSearchTime)) / 1000
        );

        this.$swal({
          text: `身份證號碼 ${searchId} 在5分鐘內已經搜尋過，請等待 ${remainingTime} 秒後再試，避免重複扣費`,
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return true;
      }

      // 清理過期的搜尋記錄
      this.cleanupExpiredSearches();

      // 標記為正在處理
      this.processingSearches.add(searchId);

      return false;
    },

    // 清理過期的搜尋記錄
    cleanupExpiredSearches() {
      const now = Date.now();
      const expiredKeys = [];

      for (const [searchId, timestamp] of this.recentSearches.entries()) {
        if (now - timestamp > 300000) {
          // 5分鐘過期
          expiredKeys.push(searchId);
        }
      }

      expiredKeys.forEach((key) => {
        this.recentSearches.delete(key);
      });
    },

    // 標記搜尋完成
    markSearchCompleted(searchId) {
      if (searchId) {
        const normalizedId = searchId.trim().toUpperCase();
        this.processingSearches.delete(normalizedId);
        this.recentSearches.set(normalizedId, Date.now());
      }
    },

    // 標記搜尋失敗（移除處理中狀態，但不添加到最近搜尋）
    markSearchFailed(searchId) {
      if (searchId) {
        const normalizedId = searchId.trim().toUpperCase();
        this.processingSearches.delete(normalizedId);
      }
    },

    // QR碼確認搜尋相關方法
    async showQRConfirmSection() {
      try {
        // 檢查是否在一小時免掃期內
        const now = Date.now();
        const storedValidUntil = localStorage.getItem('qrScanValidUntil');
        
        if (storedValidUntil && now < parseInt(storedValidUntil)) {
          // 在免掃期內，直接執行搜尋API，跳過QR確認
          console.log('QR掃描在有效期內，跳過QR確認流程');
          await this.executeDirectSearch();
          return;
        }

        // TEMP DISABLE: 暫時關閉 QR 碼，直接執行搜尋
        console.log('TEMP: 跳過 QR 碼顯示，直接執行搜尋');
        await this.executeDirectSearch();
        return;
        
        // 以下是原始 QR 碼邏輯（暫時關閉）
        /*
        // 超過一小時或首次使用，正常顯示QR碼
        // 生成QR碼
        await this.generateQRCode();

        // 顯示QR碼區域
        this.showQRCode = true;
        this.qrConfirmStatus = "pending";
        this.qrPollingCount = 0;

        // 開始輪詢檢查確認狀態
        this.startQRPolling();

        // 開始QR碼自動刷新
        this.startQRRefresh();
        */
      } catch (error) {
        // 一般錯誤處理，不再特別處理放債人牌照錯誤
        const errorMessage = error.response?.data?.message || error.message || "生成QR碼失敗，請重試";

        this.$swal({
          text: errorMessage,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    // 直接執行搜尋（跳過QR碼確認）
    async executeDirectSearch() {
      this.loading = true;
      
      try {
        // 在搜尋前獲取最新設定，確保收費計算正確
        await this.fetchLatestSettings();
        
        // 計算混合支付方式（複製自handleDownload邏輯）
        let searchLimitAvailable = this.get_supplier_info.search_limit || 0;
        let searchLimitNeeded = 1;
        
        // 計算需要的搜尋次數
        if (this.is_out_of_half_year) {
          searchLimitNeeded += 1;
        }
        if (this.is_out_of_fifteen_days) {
          searchLimitNeeded += 1;
        }
        
        // 計算實際使用的搜尋次數和剩餘需要 Coin 支付的部分
        let searchLimitToUse = Math.min(searchLimitAvailable, searchLimitNeeded);
        let useCoins = searchLimitToUse < searchLimitNeeded;
        
        // 計算需要的 X Coin
        let coinNeeded = 0;
        
        // 如果需要使用 X Coin
        if (useCoins) {
          let extraSearches = searchLimitNeeded - searchLimitToUse;
          coinNeeded = extraSearches;
          
          if (this.is_out_of_half_year) {
            coinNeeded += this.getCoinExtraRecords;
          }
          if (this.is_out_of_fifteen_days) {
            coinNeeded += this.getCoinExtraSearchRecords;
          }
        }

        const params = {
          search_record_id: this.searchQuery,
          q: this.searchQuery,
          all_record_bit: this.is_out_of_half_year,
          all_search_record_bit: this.is_out_of_fifteen_days,
          search_limit_to_use: searchLimitToUse,
          use_mixed_payment: useCoins && searchLimitToUse > 0,
          coin_needed: coinNeeded,
        };

        const response = await axiosIns.get("/record/search", {
          params: params,
        });

        // 創建類似QR確認成功的搜尋結果格式
        const searchResult = {
          search_record: response.data.search_record,
          message: "搜尋完成", 
          clientCount: response.data.clientCount || 0,
          validClientsCount: response.data.validClientsCount || 0,
          number_of_search: response.data.number_of_search || 0,
          number_of_loan: response.data.number_of_loan || 0
        };

        // 調用現有的搜尋結果處理邏輯
        this.handleSearchResult(searchResult);

      } catch (error) {
        this.loading = false;
        // 標記搜尋失敗
        this.markSearchFailed(this.searchQuery);
        console.error('直接搜尋失敗:', error);
        
        const errorMessage = error.response?.data?.message || error.message || "搜尋失敗，請重試";
        this.$swal({
          text: errorMessage,
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    async generateQRCode() {
      // TEMP DISABLE: 暫時禁用QR碼生成功能
      console.log('TEMP: QR碼生成功能已被禁用');
      return null;
      
      try {
        const response = await axiosIns.post(
          "/record/generateSearchConfirmQR",
          {
            q: this.searchQuery,
            is_out_of_half_year: this.is_out_of_half_year,
            is_out_of_fifteen_days: this.is_out_of_fifteen_days,
          }
        );

        if (response.data.success) {
          this.qrCodeData = response.data.data;

          return response.data.data;
        } else {
          throw new Error(response.data.message || "QR碼生成失敗");
        }
      } catch (error) {
        throw error;
      }
    },

    startQRPolling() {
      // TEMP DISABLE: 暫時禁用QR碼輪詢功能
      console.log('TEMP: QR碼輪詢功能已被禁用');
      return;
      
      if (this.qrPollingInterval) {
        clearInterval(this.qrPollingInterval);
      }

      this.qrPollingInterval = setInterval(async () => {
        this.qrPollingCount++;

        // 檢查是否超過最大輪詢次數
        if (this.qrPollingCount >= this.maxPollingCount) {
          this.stopQRPolling();
          this.qrConfirmStatus = "expired";
          this.$swal({
            text: "QR碼已過期，請重新生成",
            icon: "warning",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          return;
        }

        try {
          const response = await axiosIns.get(
            "/record/checkSearchConfirmStatus",
            {
              params: { token: this.qrCodeData.token },
            }
          );

          if (response.data.success) {
            if (response.data.status === "confirmed") {
              // 搜尋已確認並執行
              this.stopQRPolling();
              this.stopQRRefresh(); // 停止QR碼刷新
              this.qrConfirmStatus = "confirmed";
              this.showQRConfirmModal = false;

              // 🔧 記錄QR掃描成功時間，設置一小時免掃期
              const scanTimestamp = response.data.data.scan_timestamp || Date.now(); // 使用後端返回的時間戳，或作為後備使用當前時間
              const validUntil = scanTimestamp + this.QR_SCAN_VALIDITY_DURATION; // 一小時後過期
              this.qrScanValidUntil = validUntil;
              
              // 持久化到localStorage
              try {
                localStorage.setItem('qrScanValidUntil', validUntil.toString());
                console.log('QR掃描成功，設置一小時免掃期至:', new Date(validUntil).toLocaleString());
                console.log('使用時間戳來源:', response.data.data.scan_timestamp ? '後端' : '前端');
              } catch (error) {
                console.error('儲存QR掃描時間失敗:', error);
              }

              // 處理搜尋結果
              this.handleSearchResult(response.data.data);
            } else if (response.data.status === "expired") {
              this.stopQRPolling();
              this.stopQRRefresh(); // 停止QR碼刷新
              this.qrConfirmStatus = "expired";
              this.$swal({
                text: "QR碼已過期",
                icon: "warning",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            } else if (response.data.status === "pending") {
              // 檢測到pending狀態，後端會檢查歷史token，無需特殊處理
              console.log("等待確認中，後端支持檢查歷史token");
            }
          }
        } catch (error) {
          console.error("檢查確認狀態失敗:", error);
          // 繼續輪詢，不中斷
        }
      }, 2000); // 每2秒檢查一次
    },

    stopQRPolling() {
      if (this.qrPollingInterval) {
        clearInterval(this.qrPollingInterval);
        this.qrPollingInterval = null;
      }
    },

    startQRRefresh() {
      // TEMP DISABLE: 暫時禁用QR碼自動刷新功能
      console.log('TEMP: QR碼自動刷新功能已被禁用');
      return;
      
      // 設置刷新間隔為15秒
      this.qrRefreshCountdown = 15;

      if (this.qrRefreshInterval) {
        clearInterval(this.qrRefreshInterval);
      }

      this.qrRefreshInterval = setInterval(() => {
        this.qrRefreshCountdown--;

        if (this.qrRefreshCountdown <= 0) {
          // 直接刷新QR碼，後端會處理歷史token檢查
          this.refreshQRCode();
        }
      }, 1000); // 每秒更新倒計時
    },

    stopQRRefresh() {
      if (this.qrRefreshInterval) {
        clearInterval(this.qrRefreshInterval);
        this.qrRefreshInterval = null;
      }
    },

    async refreshQRCode() {
      // TEMP DISABLE: 暫時禁用QR碼刷新功能
      console.log('TEMP: QR碼刷新功能已被禁用');
      return;
      
      if (this.qrRefreshing) return;

      this.qrRefreshing = true;
      try {
        await this.generateQRCode();
        this.qrRefreshCountdown = 15; // 重置倒計時為15秒
      } catch (error) {
        // QR碼刷新失敗
      } finally {
        this.qrRefreshing = false;
      }
    },

    cancelQRConfirm() {
      this.stopQRPolling();
      this.stopQRRefresh();
      this.showQRCode = false;
      this.qrCodeData = null;
      this.qrConfirmStatus = "pending";
      this.qrPollingCount = 0;
      this.qrRefreshCountdown = 15;

      // 清理處理中狀態
      if (this.searchQuery) {
        this.markSearchFailed(this.searchQuery);
      }
    },

    closeQRConfirmModal() {
      this.stopQRPolling();
      this.showQRConfirmModal = false;
      this.qrCodeData = null;
      this.qrConfirmStatus = "pending";
      this.qrPollingCount = 0;

      // 清理處理中狀態
      if (this.searchQuery) {
        this.markSearchFailed(this.searchQuery);
      }
    },

    handleSearchResult(searchResult) {
      // 🔧 修復：設置loading為false，避免背景持續loading
      this.loading = false;
      
      // 記錄QR掃描成功時間（設置一小時有效期）
      const qrValidUntil = Date.now() + this.QR_SCAN_VALIDITY_DURATION;
      this.qrScanValidUntil = qrValidUntil;
      localStorage.setItem('qrScanValidUntil', qrValidUntil.toString());
      console.log('QR掃描成功，設置一小時有效期至:', new Date(qrValidUntil).toLocaleString());

      // 標記搜尋完成（在清空輸入框前）
      const searchId = this.searchQuery;
      this.markSearchCompleted(searchId);

      // 隱藏QR碼區域
      this.cancelQRConfirm();

      // 🔧 添加上傳率檢查邏輯（從原來的 isVaild 函數移植）
      const clientCount = searchResult.clientCount || 0;
      const validClientsCount = searchResult.validClientsCount || 0;
      let uploadRateMsg = "";

      if (clientCount != 0 && validClientsCount / clientCount < 0.3) {
        if (clientCount == 30 || clientCount == 35 || clientCount == 40) {
          uploadRateMsg =
            "溫馨提示:因上傳率不足而作出提示，為避令你的信貸查詢有誤，請上傳過往的查閱過的信貸紀錄，謝謝。";
        }
        if (clientCount > 50) {
          uploadRateMsg =
            "溫馨提示:因上傳率不足，你的查詢功能已被停用，請聯絡我們的客服。";

          // 如果上傳率過低且查詢次數超過50，停止處理並顯示警告
          this.$swal({
            title: "",
            width: "670px",
            html: uploadRateMsg,
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          // 清空搜尋輸入框
          this.searchQuery = "";
          return;
        }
      }

      // 清空搜尋輸入框
      this.searchQuery = "";

      // 處理搜尋結果，類似原來的handleDownload成功回調
      this.$store.dispatch("app/fetchCoinsBalance");
      this.fetchSuppliersInfo();

      // 如果有上傳率警告，先顯示警告再顯示成功訊息
      if (uploadRateMsg && clientCount <= 50) {
        this.$swal({
          title: "",
          width: "670px",
          html: uploadRateMsg,
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        }).then(() => {
          // 顯示成功訊息
          this.showSuccessMessage(searchResult);
        });
      } else {
        // 直接顯示成功訊息
        this.showSuccessMessage(searchResult);
      }

      if (searchResult.search_record) {
        // QR碼搜尋成功後也調用 updateSnapshot 確保數據完整性
        const searchRecordId = searchResult.search_record.id;

        this.$store
          .dispatch("app/updateSearchRecordSnapshot", {
            search_record_id: searchRecordId,
          })
          .then((updateResponse) => {
            console.log("QR碼搜尋後快照更新成功", updateResponse.data);

            // 使用更新後的數據
            if (updateResponse.data.search_record) {
              this.pdfData = updateResponse.data.search_record;
              this.number_of_search = updateResponse.data.number_of_search;
              this.number_of_loan = updateResponse.data.number_of_loan;
            } else {
              // 如果更新失敗，使用原始數據
              this.pdfData = searchResult.search_record;
              this.number_of_loan = searchResult.number_of_loan || 0;
              this.number_of_search = searchResult.number_of_search || 0;
            }

            // 數據準備完成後才打開 modal
            this.$bvModal.show("modal-PDF");
          })
          .catch((updateError) => {
            console.log("QR碼搜尋後快照更新失敗，使用原始數據", updateError);

            // 如果快照更新失敗，使用原始搜尋結果
            this.pdfData = searchResult.search_record;
            this.number_of_loan = searchResult.number_of_loan || 0;
            this.number_of_search = searchResult.number_of_search || 0;

            // 數據準備完成後才打開 modal
            this.$bvModal.show("modal-PDF");
          });
      }

      // 搜尋成功後重新顯示驗證碼保護
      this.resetAuthenticatorProtection();
      this.refetchData();
    },

    // 🔧 新增：顯示成功訊息的輔助方法
    showSuccessMessage(searchResult) {
      this.$swal({
        text: searchResult.message || "搜尋完成",
        confirmButtonText: "確定",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        showClass: {
          popup: "animate__animated animate__bounceIn",
        },
        buttonsStyling: false,
      });
    },

    // 更新搜尋次數
    updateSearchCount(newCount) {
      this.number_of_search = newCount;
      console.log("搜尋次數已更新:", newCount);
    },

    // 更新貸款次數
    updateLoanCount(newCount) {
      this.number_of_loan = newCount;
      console.log("貸款次數已更新:", newCount);
    },

    // 獲取最新設定（帶快取機制）
    async fetchLatestSettings() {
      const now = Date.now();
      // 如果3分鐘內已獲取過，使用快取
      if (this.settingsLastFetched && (now - this.settingsLastFetched) < 3 * 60 * 1000) {
        return this.latestSettings;
      }

      try {
        const response = await this.$http.get('/info');
        this.latestSettings = response.data.supplier;
        this.settingsLastFetched = now;
        return this.latestSettings;
      } catch (error) {
        console.log('獲取最新設定失敗，使用快取設定:', error);
        return this.latestSettings || this.$store.state.app.user_info.info;
      }
    },
  },
  mounted() {
    // 獲取 Coin 餘額
    this.$store.dispatch("app/fetchCoinsBalance");

    // 🔧 恢復QR掃描狀態（在重置認證保護之前）
    this.restoreQRScanState();

    // 頁面載入時重新顯示驗證碼保護
    this.resetAuthenticatorProtection();

    // 獲取最新通告
    this.fetchLatestAnnouncement();

    // 檢查是否有未處理的放債人牌照申請
    this.checkPendingMoneylenderRequest();

    // 啟動驗證碼清理定時器（每分鐘清理一次過期記錄）
    this.codeCleanupInterval = setInterval(() => {
      this.cleanupExpiredCodes();
    }, 60000); // 60秒
  },

  beforeDestroy() {
    // 清理QR碼相關定時器
    this.stopQRPolling();
    this.stopQRRefresh();

    // 清理QR掃描緩存
    this.clearQRScanCache();

    // 清理驗證碼清理定時器
    if (this.codeCleanupInterval) {
      clearInterval(this.codeCleanupInterval);
      this.codeCleanupInterval = null;
    }
  },
  setup() {
    const {
      fetchSearchs,
      tableColumns,
      perPage,
      currentPage,
      totalSearchs,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSearchListTable,
      refetchData,
      fetchSuppliersInfo,
      ability,
      calUploadRate,
      calNoUpload,
    } = useSearchsList();

    return {
      // Sidebar
      fetchSearchs,
      tableColumns,
      perPage,
      currentPage,
      totalSearchs,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSearchListTable,
      refetchData,
      fetchSuppliersInfo,
      ability,
      calUploadRate,
      calNoUpload,
    };
  },
};
</script>

<style scoped>
@keyframes pulse-highlight {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
    border-color: #28a745;
  }
  50% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0.3);
    border-color: #28a745;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    border-color: #28a745;
  }
}

.authenticator-input-highlight {
  animation: pulse-highlight 1.5s ease-in-out 3;
  border-color: #28a745 !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

// 驗證碼輸入框高亮特效
@keyframes pulse-highlight {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
    border-color: #28a745;
  }
  50% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0.3);
    border-color: #28a745;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    border-color: #28a745;
  }
}

.authenticator-input-highlight {
  animation: pulse-highlight 1.5s ease-in-out 3;
  border-color: #28a745 !important;
}

.records_count_card {
  .info-item {
    line-height: 2.5;
    span {
      color: #22c48b;
    }
  }
}

// QR碼確認對話框樣式
.qr-code-container {
  display: inline-block;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid #e9ecef;

  svg {
    display: block;
    max-width: 100%;
    height: auto;
  }
}

.search-params-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #007bff;

  .param-item {
    margin-bottom: 8px;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.status-info {
  .status-pending {
    color: #6c757d;
    font-weight: 500;
  }

  .status-confirmed {
    font-weight: 500;
  }

  .status-expired {
    font-weight: 500;
  }
}

.instructions {
  font-size: 14px;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.action-buttons {
  border-top: 1px solid #e9ecef;
  padding-top: 20px;
}

// QR碼區域樣式
.qr-code-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #007bff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);

  .qr-code-container {
    .qr-code-header {
      h6 {
        font-weight: 600;
      }
    }

    .qr-code-display {
      .qr-code-wrapper {
        display: inline-block;
        padding: 15px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        border: 1px solid #e9ecef;

        svg {
          display: block;
          max-width: 100%;
          height: auto;
        }
      }
    }

    .search-params-summary {
      background: white;
      border-radius: 8px;
      padding: 15px;
      border-left: 4px solid #007bff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .param-item {
        font-size: 14px;
        color: #495057;
      }
    }

    .qr-actions {
      .btn {
        border-radius: 6px;
        font-weight: 500;
      }
    }
  }
}

// 走馬燈通告樣式
.announcement-marquee-container {
  background: #ffffff;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    background: #f8f9fa;
    
    .marquee-content {
      animation-play-state: paused;
    }
  }
}

.announcement-marquee {
  height: 48px;
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
}

.marquee-content {
  display: flex;
  align-items: center;
  animation: marquee 45s linear infinite;
  width: max-content;
}

.marquee-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding-right: 50px; // 確保有間距再重複
  
  .announcement-label {
    color: #6f42c1;
    font-weight: 600;
    margin-right: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }
  
  .announcement-title {
    color: #1e3d59; // 深藍色
    font-weight: 700;
    font-size: 15px;
    margin-right: 16px;
    flex-shrink: 0;
  }
  
  .announcement-text {
    color: #495057;
    font-size: 14px;
    line-height: 1.4;
  }
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

// 響應式設計
@media (max-width: 768px) {
  .announcement-marquee-container {
    margin-left: -15px;
    margin-right: -15px;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
  
  .announcement-marquee {
    height: 44px;
  }
  
  .marquee-content {
    .announcement-text {
      font-size: 13px;
    }
  }
}

@media (max-width: 576px) {
  .announcement-marquee {
    height: 40px;
  }
  
  .marquee-content {
    animation-duration: 35s; // 在小螢幕上稍微加快速度
    
    .announcement-label {
      margin-right: 8px;
      gap: 4px;
    }
    
    .announcement-text {
      font-size: 12px;
    }
  }
}

/* ===================================== */
/* 破產記錄及法院案件統一搜尋樣式 */
/* ===================================== */

/* 破產記錄表格樣式 */
.bankruptcy-search-table {
  margin-bottom: 0;
}




::v-deep .bankruptcy-search-table tbody td .badge {
  font-size: 0.75rem;
  padding: 4px 8px;
}

/* 姓名欄位美化 */
.name-text {
  font-size: 0.9rem;
  color: #2c3e50;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
  max-width: 100%;
}

/* 表格整體美化 */
::v-deep .bankruptcy-search-table {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border-radius: 8px;
  overflow: hidden;
  table-layout: fixed;
  width: 100%;
}

::v-deep .bankruptcy-search-table thead th {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #007bff;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

::v-deep .bankruptcy-search-table tbody tr {
  transition: all 0.2s ease;
}

::v-deep .bankruptcy-search-table tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,123,255,0.15);
}

::v-deep .bankruptcy-search-table tbody td {
  border-top: 1px solid #f1f3f5;
  vertical-align: middle;
  padding: 12px 8px;
  font-size: 0.875rem;
  white-space: nowrap;
}

/* 法院案件表格樣式 */
.court-cases-search-table {
  margin-bottom: 0;
}

::v-deep .court-cases-search-table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  font-size: 0.875rem;
  white-space: nowrap;
  padding: 12px 8px;
}

::v-deep .court-cases-search-table tbody td {
  padding: 10px 8px;
  font-size: 0.875rem;
  vertical-align: top;
}

::v-deep .court-cases-search-table tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.05);
}

::v-deep .court-cases-search-table tbody td .badge {
  font-size: 0.75rem;
  padding: 4px 8px;
}

/* 特殊處理訴訟各方和應訊代表欄位 */
::v-deep .court-cases-search-table tbody td:nth-child(7),
::v-deep .court-cases-search-table tbody td:nth-child(8) {
  max-width: 300px;
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.4;
}

/* 搜尋結果資訊樣式 */
.search-result-compact {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-left: 3px solid #28a745;
  font-size: 0.9rem;
}

.search-result-compact-court {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-left: 3px solid #17a2b8;
  font-size: 0.9rem;
}

/* 按鈕高度統一 */
.btn-same-height {
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  line-height: 1.5 !important;
  padding: 0.375rem 0.75rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid !important;
  box-sizing: border-box !important;
}

.search-input {
  height: 38px !important;
}

::v-deep .form-control {
  height: 38px !important;
}

::v-deep .form-group {
  margin-bottom: 0 !important;
}

/* 案件類型徽章樣式修正 */
.case-type-badge {
  background-color: #6c757d !important;
  color: white !important;
  border: 1px solid #5a6268 !important;
  font-weight: 500 !important;
}

/* 響應式改進 */
@media (max-width: 1200px) {
  ::v-deep .court-cases-search-table tbody td {
    padding: 8px 6px;
    font-size: 0.8rem;
  }

  ::v-deep .court-cases-search-table thead th {
    padding: 10px 6px;
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  ::v-deep .bankruptcy-search-table {
    font-size: 0.75rem;
  }

  ::v-deep .bankruptcy-search-table tbody td {
    padding: 6px 4px;
  }

  ::v-deep .bankruptcy-search-table thead th {
    padding: 8px 4px;
    font-size: 0.75rem;
  }

  ::v-deep .court-cases-search-table {
    font-size: 0.75rem;
  }

  ::v-deep .court-cases-search-table tbody td {
    padding: 6px 4px;
  }

  ::v-deep .court-cases-search-table thead th {
    padding: 8px 4px;
    font-size: 0.75rem;
  }

  ::v-deep .court-cases-search-table tbody td:nth-child(7),
  ::v-deep .court-cases-search-table tbody td:nth-child(8) {
    max-width: 200px;
  }

  .search-result-compact,
  .search-result-compact-court {
    flex-direction: column;
    text-align: center;
  }

  /* 手機版按鈕改為垂直排列並增加間距 */
  .btn-same-height {
    width: 100% !important;
    margin-bottom: 0.5rem !important;
  }

  .btn-same-height:last-child {
    margin-bottom: 0 !important;
  }
}

@media (max-width: 767px) {
  .search-result-compact .result-count,
  .search-result-compact-court .result-count {
    margin-top: 10px;
  }
}

.dashboard-tabs .card-header{
  padding-bottom: 0px;
}

.dashboard-tabs .nav-tabs .nav-link {
  background-color: white !important;
  color: #495057 !important;
  border-color: #dee2e6 !important;
}

.dashboard-tabs .nav-tabs .nav-link.active {
  background-color: #22c48b !important;
  color: white !important;
  border-color: #22c48b !important;
}
</style>
